<div class="row animated fadeIn">
  <div class="col-md-12">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/orderReview/orderreview"><span
            class="mdi mdi-arrow-left"></span></a>Edit Order Review</h4>
    </div>
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <ngb-tabset #t="ngbTabset" [(activeId)]="active" class="commercial-tabs">
              <ngb-tab id="tab-selectbyid1" title="Order Review">
                <ng-template ngbTabContent>
                  <div class="mt-3">
                    <div class="div-container">
                      <ngb-accordion #acc="ngbAccordion" activeIds="config-panel-one">
                        
                        <ngb-panel title="Order Information" id="config-panel-one" class="fade mdi mdi-power-socket-eu">
                          <ng-template ngbPanelContent>
                            <form [formGroup]="registerForm">
                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-inline-block justify-content-between align-items-center">MTI
                                    Number
                                  </label>
                                  <input class="form-control-plaintext" type="text" [(ngModel)]="MTINum"
                                    placeholder="{{MTINum}}" readonly [ngModelOptions]="{standalone: true}" />
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-inline-block justify-content-between align-items-center">Status
                                  </label>
                                  <input class="form-control-plaintext" type="text" [(ngModel)]="Status"
                                    placeholder="{{Status}}" readonly [ngModelOptions]="{standalone: true}" />
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="!Stage">
                                  <label for="" class="d-inline-block justify-content-between align-items-center">Stage
                                  </label>
                                  <input class="form-control-plaintext" type="text" [(ngModel)]="draft"
                                    placeholder="{{draft}}" readonly [ngModelOptions]="{standalone: true}" />
                                </div>
                                <div class="col-lg-3 col-md-6 form-group" *ngIf="Stage">
                                  <label for="" class="d-flex align-items-center">Stages<span
                                      class="required ml-1">*</span>
                                  </label>
                                  <angular2-multiselect formControlName="Stage" [settings]="dropdownSetting8"
                                    [data]="showStage" [(ngModel)]="selectedstage" (onSelect)="onStageSelect($event)"
                                    (onDeSelect)="onStageSelect($event)" (onSelectAll)="onStageSelect($event)"
                                    (onDeSelectAll)="onStageSelect($event)" fixSearchBug>
                                  </angular2-multiselect>
                                  <div *ngIf="submitted && f.Stage.errors" class="invalid-feedback">
                                    <div *ngIf="f.Stage.errors.required">Stages is required</div>
                                  </div>
                                </div>
                              </div>
                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="soOption === 'Cash Only'">
                                  <label for="" class="d-inline-block justify-content-between align-items-center">SO
                                    Option<span class="required ml-1">*</span>
                                  </label>
                                  <input class="form-control" type="text" [(ngModel)]="soOption"
                                    formControlName="soOptions" placeholder="{{soOption}}" readonly />
                                </div>
                                <div class="col-lg-3 col-md-6 form-group" *ngIf="soOption !== 'Cash Only'">
                                  <label for="" class="d-flex align-items-center">SO Options are - <span
                                      class="required ml-1">*</span>
                                  </label>
                                  <angular2-multiselect [data]="SoOption" formControlName="soOptions"
                                    [(ngModel)]="selectedSo" [settings]="dropdownSo" (onSelect)="onSoSelect($event)"
                                    (onDeSelect)="onSoDeSelect($event)"></angular2-multiselect>
                                  <div
                                    *ngIf="registerForm.get('soOptions').invalid && registerForm.get('soOptions').errors && (registerForm.get('soOptions').dirty || registerForm.get('soOptions').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="registerForm.get('soOptions').hasError('required')">
                                      SO Options are Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-6 form-group">
                                  <label for="" class="d-flex align-items-center">Critical Shipment - <span
                                      class="required ml-1">*</span>
                                  </label>
                                  <select class="form-control" formControlName="criticalShipment">
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                  </select>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Project Name (Project ID)
                                    <span class="required ml-1">*</span></label>
                                  <input class="form-control" formControlName="ProjectId" type="text"
                                    [(ngModel)]="projectValue" placeholder="{{projectValue}}" readonly />
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Inquiry Name (Inquiry ID)
                                    <span class="required ml-1">*</span></label>
                                  <input class="form-control" formControlName="inquiry" type="text"
                                    [(ngModel)]="InquiryValue" placeholder="{{InquiryValue}}" readonly />
                                </div>
                              </div>
                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Client Name
                                    <span class="required ml-1">*</span></label>
                                  <input class="form-control" formControlName="clientName" type="text"
                                    placeholder="{{client}}" [(ngModel)]="clientName" readonly />
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Business Vertical
                                    <span class="required ml-1">*</span></label>
                                  <input class="form-control" type="text" [(ngModel)]="vertical"
                                    placeholder="{{verticalName}}" [ngModelOptions]="{standalone: true}" readonly />
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Business Category
                                    <span class="required ml-1">*</span></label>
                                  <textarea class="form-control" [(ngModel)]="category"
                                    [ngModelOptions]="{standalone: true}" readonly
                                    placeholder="{{categoryName}}"></textarea>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="soOption === 'Cash Only'">
                                  <label for="" class="d-flex align-items-center">Client
                                    SO / AGR # (Received)<span class="required ml-1">*</span>
                                  </label>
                                  <input class="form-control" type="text" [(ngModel)]="clientSo"
                                    formControlName="clientSoReceive" placeholder="{{clientSo}}" readonly />
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="soOption !== 'Cash Only'">
                                  <label for="" class="d-flex  align-items-center">Client SO / AGR # (Received)
                                    <span class="required ml-1">*</span></label>
                                  <select class="form-control" formControlName="clientSoReceive">
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                    <option value="Not Applicable">Not Applicable</option>
                                  </select>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="clientSoNumber">
                                  <label for="" class="d-flex  align-items-center">Client SO Number
                                    <span class="required ml-1">*</span></label>
                                  <input class="form-control" formControlName="clientSoNumber" type="text"
                                    maxlength="50" (input)="NameSpaceNotAllowed($event)"
                                    [ngClass]="{'is-invalid': submitted && f.clientSoNumber.errors}" />
                                  <div *ngIf="submitted && f.clientSoNumber.errors" class="invalid-feedback">
                                    <div *ngIf="f.clientSoNumber.errors.required">Client SO Number is Required.</div>
                                  </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="clientSoDate">
                                  <label for="" class="d-flex align-items-center">Client SO Date
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="bg-calender-icon form-control" id="inlineFormInputGroup"
                                      placeholder="DD-MM-YYYY" bsDatepicker [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
                                      (keydown)="disableDate()" [minDate]="InquiryReceivedDate" autocomplete="off"
                                      [ngClass]="{'is-invalid': submitted && f.clientSoDate.errors}"
                                      (ngModelChange)="newFunc3($event)" formControlName="clientSoDate">
                                    <div *ngIf="submitted && f.clientSoDate.errors" class="invalid-feedback">
                                      <div *ngIf="f.clientSoDate.errors.required">Client SO Date is Required.</div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="soReceiveDate">
                                  <label for="" class="d-flex align-items-center">SO Received Date (Actual)
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="bg-calender-icon form-control" id="inlineFormInputGroup"
                                      (keydown)="disableDate()" placeholder="DD-MM-YYYY" bsDatepicker
                                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}" formControlName="soReceiveDate"
                                      [minDate]="InquiryReceivedDate" autocomplete="off"
                                      [ngClass]="{'is-invalid': submitted && f.soReceiveDate.errors}">
                                    <div *ngIf="submitted && f.soReceiveDate.errors" class="invalid-feedback">
                                      <div *ngIf="f.soReceiveDate.errors.required">SO Received Date (Actual) is
                                        Required.</div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="clientExDate">
                                  <label for="" class="d-flex align-items-center">Client SO Expected Date
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="bg-calender-icon form-control" id="inlineFormInputGroup"
                                      [minDate]="InquiryReceivedDate" [maxDate]="maxClientExDate"
                                      placeholder="DD-MM-YYYY" bsDatepicker [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
                                      formControlName="clientExDate" (keydown)="disableDate()"
                                      (ngModelChange)="newFunc3($event)" autocomplete="off"
                                      [ngClass]="{'is-invalid': submitted && f.clientExDate.errors}">
                                    <div *ngIf="submitted && f.clientExDate.errors" class="invalid-feedback">
                                      <div *ngIf="f.clientExDate.errors.required">Client SO Expected Date is Required.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group col-lg-6 col-md-6 col-sm-12">
                                  <label for="" class="d-flex align-items-center">SO Remarks
                                    <span class="required ml-1">*</span></label>
                                  <textarea class="form-control" formControlName="remarkRcDate"
                                    maxlength="200"></textarea>
                                  <div
                                    *ngIf="registerForm.get('remarkRcDate').invalid && registerForm.get('remarkRcDate').errors && (registerForm.get('remarkRcDate').dirty || registerForm.get('remarkRcDate').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="registerForm.get('remarkRcDate').hasError('required')">
                                      SO Remarks is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12"
                                  *ngIf="clientSo === 'Not Applicable'">
                                  <label for="" class="d-flex align-items-center">SO
                                    Acknowledgement<span class="required ml-1">*</span>
                                  </label>
                                  <input class="form-control" type="text" [(ngModel)]="acknowledge"
                                    formControlName="acknowledge" placeholder="{{acknowledge}}" readonly />
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12"
                                  *ngIf="clientSo !== 'Not Applicable'">
                                  <label for="" class="d-flex  align-items-center">SO Acknowledgement
                                    <span class="required ml-1">*</span></label>
                                  <angular2-multiselect [data]="AcKnowledge" formControlName="acknowledge"
                                    [(ngModel)]="selectedAc" [settings]="dropdownAc"
                                    (onSelect)="onAcknowledgeSelect($event)"
                                    (onDeSelect)="onAcknowledgeSelect($event)"></angular2-multiselect>
                                  <div
                                    *ngIf="registerForm.get('acknowledge').invalid && registerForm.get('acknowledge').errors && (registerForm.get('acknowledge').dirty || registerForm.get('acknowledge').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="registerForm.get('acknowledge').hasError('required')">
                                      SO Acknowledgement is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="Date">
                                  <label for="" class="d-flex align-items-center">SO Acknowledgement Date
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="form-control" id="inlineFormInputGroup"
                                      [minDate]="minSoAckDate" placeholder="DD-MM-YYYY" bsDatepicker
                                      formControlName="Date" autocomplete="off" (keydown)="disableDate()"
                                      [ngClass]="{'is-invalid': submitted && f.Date.errors}"
                                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}" [maxDate]="maxSoAckDate">
                                    <div *ngIf="submitted && f.Date.errors" class="invalid-feedback">
                                      <div *ngIf="f.Date.errors.required">SO Acknowledge Date is Required</div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12"
                                  *ngIf="clientSo === 'Not Applicable'">
                                  <label for="" class="d-flex align-items-center">Project execution<span
                                      class="required ml-1">*</span>
                                  </label>
                                  <input class="form-control" type="text" [(ngModel)]="projectEx"
                                    formControlName="projectExec" placeholder="{{projectEx}}" readonly />
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12"
                                  *ngIf="clientSo !== 'Not Applicable'">
                                  <label for="" class="d-flex  align-items-center">Project execution
                                    <span class="required ml-1">*</span></label>
                                  <angular2-multiselect [data]="ProjectEx" formControlName="projectExec"
                                    [(ngModel)]="selectedProjectEx" [settings]="dropdownProjectEx"
                                    (onSelect)="onProjectExSelect($event)"
                                    (onDeSelect)="onProjectExDeSelect($event)"></angular2-multiselect>
                                  <div
                                    *ngIf="registerForm.get('projectExec').invalid && registerForm.get('projectExec').errors && (registerForm.get('projectExec').dirty || registerForm.get('projectExec').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="registerForm.get('projectExec').hasError('required')">
                                      Project execution is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex align-items-center">Equipment Delivery Date
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="form-control" id="inlineFormInputGroup"
                                      placeholder="DD-MM-YYYY" bsDatepicker autocomplete="off"
                                      (ngModelChange)="newFunc2($event); newFunc4($event)" [minDate]="maxEqDeliverDate"
                                      formControlName="eqDeliveryDate" (keydown)="disableDate()"
                                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}" autocomplete="off">
                                  </div>
                                  <div
                                    *ngIf="registerForm.get('eqDeliveryDate').invalid && registerForm.get('eqDeliveryDate').errors && (registerForm.get('eqDeliveryDate').dirty || registerForm.get('eqDeliveryDate').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="registerForm.get('eqDeliveryDate').hasError('required')">
                                      Equip Delivery Date is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-lg-9 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Equipment Delivery Remarks
                                    <span class="required ml-1">*</span></label>
                                  <textarea class="form-control" formControlName="eqDeliveryRemark"
                                    maxlength="200"></textarea>
                                  <div
                                    *ngIf="registerForm.get('eqDeliveryRemark').invalid && registerForm.get('eqDeliveryRemark').errors && (registerForm.get('eqDeliveryRemark').dirty || registerForm.get('eqDeliveryRemark').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="registerForm.get('eqDeliveryRemark').hasError('required')">
                                      Equip Delivery Remarks is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Scope of Work
                                    <span class="required ml-1">*</span></label>
                                  <textarea class="form-control" formControlName="scopeWork" maxlength="500"></textarea>
                                  <div
                                    *ngIf="registerForm.get('scopeWork').invalid && registerForm.get('scopeWork').errors && (registerForm.get('scopeWork').dirty || registerForm.get('scopeWork').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="registerForm.get('scopeWork').hasError('required')">
                                      Scope of Work is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Client Point of Contact
                                    <span class="required ml-1">*</span></label>
                                  <angular2-multiselect formControlName="clientContact" [data]="showContact"
                                    [(ngModel)]="selectedcontact" [settings]="dropdownSetting6"
                                    (onSelect)="onContactSelect($event)" (onDeSelect)="onContactSelect($event)"
                                    (onSelectAll)="onContactSelect($event)" (onDeSelectAll)="onContactSelect($event)"
                                    fixSearchBug>
                                  </angular2-multiselect>
                                  <div
                                    *ngIf="registerForm.get('clientContact').invalid && registerForm.get('clientContact').errors && (registerForm.get('clientContact').dirty || registerForm.get('clientContact').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="registerForm.get('clientContact').hasError('required')">
                                      Client Contact is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-6 form-group">
                                  <label for="" class="d-flex align-items-center">Consultant Approval<span
                                      class="required ml-1">*</span>
                                  </label>
                                  <select class="form-control" formControlName="ConsultantApproval">
                                    <option value=1>Applicable</option>
                                    <option value=0>Not Applicable</option>
                                  </select>
                                  <div
                                    *ngIf="registerForm.get('ConsultantApproval').invalid && registerForm.get('ConsultantApproval').errors && (registerForm.get('ConsultantApproval').dirty || registerForm.get('ConsultantApproval').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="registerForm.get('ConsultantApproval').hasError('required')">
                                      Consultant Approval is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-lg-6 col-md-12 col-sm-12"
                                  *ngIf="registerForm.value.ConsultantApproval == 0">
                                  <label for="" class="d-flex  align-items-center">Reason
                                    <span class="required ml-1">*</span></label>
                                  <textarea class="form-control" formControlName="ConsultantApprovalRemark"
                                    maxlength="200"></textarea>
                                  <div
                                    *ngIf="registerForm.get('ConsultantApprovalRemark').invalid && registerForm.get('ConsultantApprovalRemark').errors && (registerForm.get('ConsultantApprovalRemark').dirty || registerForm.get('ConsultantApprovalRemark').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="registerForm.get('ConsultantApprovalRemark').hasError('required')">
                                      Consultant Approval Not Applicable Reason is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Remarks
                                    <span class="required ml-1">*</span></label>
                                  <textarea class="form-control" formControlName="Remark" maxlength="200"></textarea>
                                  <div
                                    *ngIf="registerForm.get('Remark').invalid && registerForm.get('Remark').errors && (registerForm.get('Remark').dirty || registerForm.get('Remark').touched) || submitted">
                                    <small class="text-danger" *ngIf="registerForm.get('Remark').hasError('required')">
                                      Remark is Required.
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="row mb-3">
                                <div class="col-lg-12">
                                  <a href="javascript:void(0);" class="btn btn-info" (click)="onSubmit()">Save</a>
                                </div>
                              </div>
                            </form>
                            <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                          </ng-template>
                        </ngb-panel>

                        <ngb-panel title="Item Description" class="fade" (click)="togglePanel('config-panel-two')">
                          <ng-template ngbPanelContent id="config-panel-two">
                            <div class="form-group">
                              <form [formGroup]="itemDescription">
                                <div class="form-row">
                                  <div class="w-100"></div>
                                  <div class="form-group col-sm-12">
                                    <div class="form-row">
                                      <label for="" class="d-flex align-items-center col-md-4">Base Currency Rate<span
                                          class="required">*</span>
                                      </label>
                                      <label for="" class="d-flex col-md-3">Reported
                                      </label>
                                    </div>
                                    <div class="form-row">
                                      <div class="col-md-1">
                                        <input class="form-control text-right" style="padding-right: 10px !important;"
                                          type="text" readonly value="1" />
                                      </div>
                                      <div class="col-md-2" *ngIf="dollar==false">
                                        <angular2-multiselect [data]="showCurrency" [(ngModel)]="selectedCurrency"
                                          [settings]="CurrencySetting"
                                          [ngClass]="{ 'is-invalid': submitted1 && i.Currency.errors}"
                                          (onSelect)="onCurrencySelect($event)" (onDeSelect)="onCurrencySelect($event)"
                                          formControlName="Currency" fixSearchBug (input)="NameSpaceNotAllowed($event)">
                                        </angular2-multiselect>
                                        <div *ngIf="submitted1 && i.Currency.errors" class="invalid-feedback">
                                          <div *ngIf="i.Currency.errors.required">Currency is required</div>
                                        </div>
                                      </div>
                                      <div class="col-md-2" *ngIf="dollar==true">
                                        <input class="form-control text-right" type="text" formControlName="Currency"
                                          [(ngModel)]="currency" readonly />
                                      </div>

                                      <div class="col-md-1" *ngIf="dollar==false">
                                        <input class="form-control text-right" style="padding-right: 10px !important;"
                                          type="text" appTwoDigitDecimaNumber min="0"
                                          formControlName="ReportedCurrencyRate"
                                          [ngClass]="{ 'is-invalid': submitted1 && i.Currency.errors}" maxlength="8"
                                          (keyup)="getValue($event); totalsum()"
                                          (keypress)="preventDecimalInput($event,'ReportedCurrencyRate')"
                                          ondrop="return false;" />
                                        <div *ngIf="submitted1 && i.ReportedCurrencyRate.errors"
                                          class="invalid-feedback">
                                          <div
                                            *ngIf="itemDescription.get('ReportedCurrencyRate').invalid && 
                                                itemDescription.get('ReportedCurrencyRate').errors && 
                                                   (itemDescription.get('ReportedCurrencyRate').dirty || 
                                                     itemDescription.get('ReportedCurrencyRate').touched) || submitted1">
                                            <div *ngIf="i.ReportedCurrencyRate.errors.required">ReportedCurrencyRate is
                                              required
                                            </div>
                                          </div>
                                        </div>
                                        <div *ngIf="itemDescription.get('ReportedCurrencyRate').invalid && 
                                            itemDescription.get('ReportedCurrencyRate').errors && 
                                               (itemDescription.get('ReportedCurrencyRate').dirty || 
                                                  itemDescription.get('ReportedCurrencyRate').touched) || submitted1">
                                          <small class="text-danger"
                                            *ngIf="itemDescription.get('ReportedCurrencyRate').hasError('max')">
                                            Currency can't be greater than 99999.99
                                          </small>
                                        </div>
                                      </div>

                                      <div class="col-md-1" *ngIf="dollar==true">
                                        <input class="form-control text-right" type="text"
                                          formControlName="ReportedCurrencyRate" readonly />
                                      </div>

                                      <div class="col-md-1">
                                        <input class="form-control" type="text" readonly value="QAR" />
                                      </div>

                                      <div *ngIf="draft == 'Draft' || draft == 'Pending MTI'">
                                        <div class="row justify-content-start mb-2 zIndexUp" *ngIf="dollar==false">
                                          <ul class="list-unstyled action-tool-bar col-md-12 col-sm-12 mb-0">
                                            <li class="pt-1">
                                              <button href="javascript:void(0);" class="btn btn-sm btn-light-info"
                                                (click)="currencySave()">
                                                <span class="mdi mdi-content-save"></span>Save
                                              </button>
                                            </li>
                                          </ul>
                                        </div>
                                        <div class="row justify-content-start align-items-center mb-2 zIndexUp"
                                          *ngIf="dollar==true">
                                          <ul class="list-unstyled action-tool-bar col-md-12 col-sm-12 mb-0">
                                            <li class="pt-1">
                                              <a href="javascript:void(0);"
                                                class="btn btn-sm btn-light-info bg-info border-info w-100 mt-0"
                                                (click)="currencyEdit()"><span class="mdi mdi-pencil"></span>
                                                Edit
                                              </a>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="table-responsive">
                                  <table class="table order8" aria-hidden="true">
                                    <thead>
                                      <tr>
                                        <th colspan="13" class="text-center" id="" style="padding: 4px 0px!important;">
                                          Item
                                          Details </th>
                                        <th colspan="3" class="text-center" id="" style="padding: 4px 0px!important;">
                                          Execution </th>
                                        <th class="text-center" id="" style="padding: 4px 0px!important;">War. </th>
                                      </tr>
                                      <tr>
                                        <th id="">Business Vertical </th>
                                        <th id="">Business Category </th>
                                        <th id="" style="min-width:160px;max-width:168px;">Model / ITEM Name </th>
                                        <th id="" style="min-width: 166px; max-width: 132px">Brand</th>
                                        <th id="" class="text-right" style="min-width:43px;">Unit
                                          Type </th>
                                        <th id="" style="min-width:87px; max-width:78">Inq. Qty </th>
                                        <th id="">Order Qty </th>
                                        <th id="" style="min-width:60px;">Bal. Qty </th>
                                        <th id="" style="min-width:91px;max-width: 91px;">Unit Rate </th>
                                        <th id="" class="font-weight-bold" style="min-width:100px;max-width:220px;">
                                          DISCOUNT
                                          RATE % & Amt
                                        </th>
                                        <th id="" style="width:130px;">Total W/O Vat</th>
                                        <th id="" style="min-width:110px;">Tax % AMT </th>
                                        <th id="" style="width:130px;">Total Price</th>
                                        <th id="" class="text-center"
                                          style="vertical-align:super; padding: 0px !important">
                                          <div style="position: relative; top: -10px"> Inst
                                            <div class="form-check text-center">
                                              <input type="checkbox" class="form-check-input "
                                                (change)="toggleColumnCheckboxes($event,'INST')">
                                            </div>
                                          </div>
                                        </th>
                                        <th class="text-center" id=""
                                          style="min-width:46px;vertical-align:super; padding: 0px !important">
                                          <div style="position: relative; top: -10px">
                                            T & C
                                            <div class="form-check text-center">
                                              <input type="checkbox" class="form-check-input "
                                                (change)="toggleColumnCheckboxes($event,'TandC')">
                                            </div>
                                          </div>
                                        </th>
                                        <th id="" class="text-center" style="min-width: 32px; padding: 0px !important">
                                          <div style="position: relative; top: -10px">
                                            H O
                                            <div class="form-check text-center text-center">
                                              <input type="checkbox" class="form-check-input "
                                                (change)="toggleColumnCheckboxes($event,'HandingOver')">
                                            </div>
                                          </div>
                                        </th>
                                        <th id="" class="text-center"
                                          style="vertical-align:super; padding: 0px !important">
                                          <div style="position: relative; top: -10px">
                                            War.
                                            <div class="form-check text-center">
                                              <input type="checkbox" class="form-check-input "
                                                (change)="toggleColumnCheckboxes($event,'Warranty')">
                                            </div>
                                          </div>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody *ngIf="isRender">
                                      <ng-container formArrayName="ObjOrderItemDescription">
                                        <ng-container
                                          *ngFor="let row of itemDescription.controls.ObjOrderItemDescription.controls; let i = index">
                                          <tr [formArrayName]="i">
                                            <td><span class="form-control-plaintext p-0 d-block text-right"
                                                ngDefaultControl style="padding-right: 1px !important; width: 115px; "
                                                formControlName="BusinessVertical">{{row.value.BusinessVertical}}</span>
                                            </td>
                                            <td><span class="form-control-plaintext p-0 d-block text-right"
                                                ngDefaultControl style="padding-right: 1px !important; width: 115px; "
                                                formControlName="BusinessCategory">{{row.value.BusinessCategory}}</span>
                                            </td>
                                            <td><span style="min-width:163px;max-width:180px;"
                                                class="form-control-plaintext p-0 d-block text-right" ngDefaultControl
                                                style="padding-right: 1px !important; width: 115px;  float:left"
                                                formControlName="Itemcode">{{row.value.Itemcode}}</span>
                                              <button type="button" class="btn btn-link p-0" placement="top"
                                                ngbTooltip="{{descript[i]}}">
                                                <span class="mdi mdi-help-circle text-dark"></span>
                                              </button>
                                            </td>
                                            <td class="p-2" hidden>
                                              <input type="text" class="form-control p-1" formControlName="Description"
                                                placeholder={{row.value.Description}} title="{{row.value.Description}}"
                                                readonly hidden />
                                              <input type="text" class="form-control" [(ngModel)]="productId[i]"
                                                formControlName="ProductId" hidden />
                                            </td>
                                            <td><span
                                                class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                                ngDefaultControl style="padding-right: 1px !important; width: 142px; "
                                                formControlName="ProductBrandName">{{row.value.ProductBrandName}}</span>
                                            </td>
                                            <td><span class="form-control-plaintext p-0 d-block text-right "
                                                ngDefaultControl style="padding-right: 1px !important; width: 99px; "
                                                formControlName="UnitType">{{row.value.UnitType}}</span>
                                            </td>
                                            <td class="text-right"><span
                                                class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                                ngDefaultControl style="padding-right: 1px !important; width: 70px; "
                                                formControlName="InquiryQuantity">{{row.value.InquiryQuantity}}</span>
                                            </td>
                                            <td>
                                              <input type="text" class="form-control p-1 text-right" maxlength="5"
                                                formControlName="OrderQuantity"
                                                (input)="singleWhiteSpaceAllowed($event);" (keyup)="getPrice(i)"
                                                maxlength="3">
                                            </td>
                                            <td class="text-right"><span
                                                class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                                ngDefaultControl style="padding-right: 1px !important; width: 68px; "
                                                formControlName="BalanceQuantity">{{row.value.BalanceQuantity}}</span>
                                            </td>
                                            <td class="text-right">
                                              <input type="text" class="form-control p-1 text-right" style="padding-right: 10px  
                                                     !important;" maxlength="9" max="999999.99" (keyup)="getPrice(i)"
                                                (keypress)="itemsFormValidate($event, i,'UnitRate')"
                                                formControlName="UnitRate" #UnitRate
                                                [ngClass]="{'is-invalid': submitted && 
                                                     itemDescription.controls.ObjOrderItemDescription.controls[i].controls.UnitRate.errors}"
                                                appTwoDigitDecimaNumber (paste)="pasteNumbrother($event, i)"
                                                ondrop="return false;">
                                            </td>
                                            <td class="">
                                              <div class="">
                                                <div class="mb-1">
                                                  <input type="text" class="form-control form-control-sm p-1 text-right"
                                                    ondrop="return false;"
                                                    style="margin-left: 57px;min-width: 56px;max-width: 56px;min-height: 25px !important;"
                                                    formControlName="DiscountPer" maxlength="6"
                                                    placeholder="{{row.value.DiscountPer}}" max="100"
                                                    (keyup)="getPrice(i)"
                                                    (keypress)="itemsFormValidate($event, i,'DiscountPer')"
                                                    appTwoDigitDecimaNumber>
                                                  <span class="abs_percentage pt-2 pl-1 pr-1">%</span>
                                                </div>

                                                <input type="text" class="form-control form-control-sm p-1 text-right"
                                                  style="margin-bottom: 2px;margin-left: 11px;min-width: 57px;max-width: 103px;min-height: 25px !important;"
                                                  formControlName="TotalDiscountValue" (keyup)="getPrice1(i)"
                                                  (keypress)="itemsFormValidate($event, i,'TotalDiscountValue')"
                                                  maxlength="9" appTwoDigitDecimaNumber>
                                                <span
                                                  class="abs_percentage pt-2 pl-1 pr-1 overflow-hidden d-none">%</span>
                                              </div>
                                            </td>
                                            <td class="text-right">
                                              <span *ngIf="currency != 'QAR'"
                                                class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                                ngDefaultControl style="padding-right: 1px !important; width: 133px; "
                                                formControlName="TotalPrice"
                                                appTwoDigitDecimaNumber>{{formatNumber(row.value.TotalPrice, 2)}}
                                                ({{currency}})</span>
                                              <span
                                                class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                                ngDefaultControl style="padding-right: 1px !important; width: 133px; "
                                                formControlName="TotalPriceQAR" appTwoDigitDecimaNumber
                                                min="1">{{row.value.TotalPriceQAR}}
                                                (QAR)</span>
                                            </td>
                                            <td class="text-right">
                                              <div class="d-flex"> <input type="text"
                                                  class="form-control form-control-sm p-1 text-right"
                                                  ondrop="return false;"
                                                  style="margin-left: 54px; min-width: 62px; max-width:62px;"
                                                  formControlName="VatRate" maxlength="6"
                                                  placeholder="{{row.value.VatRate}}" max="100" [(ngModel)]="vat[i]"
                                                  (keyup)="getPrice(i)"
                                                  (keypress)="itemsFormValidate($event, i,'VatRate')"
                                                  appTwoDigitDecimaNumber> <span class="pl-1 pt-2">%</span>
                                              </div>
                                              <span
                                                class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                                style="margin-left: 51px; width:64px; " ngDefaultControl
                                                formControlName="VatValue" (keyup)="getPrice(i)"
                                                appTwoDigitDecimaNumber>{{formatNumber(row.value.VatValue, 2)}}</span>
                                            </td>
                                            <td class="text-right">
                                              <span *ngIf="currency != 'QAR'"
                                                class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                                ngDefaultControl style="padding-right: 1px !important; width: 133px; "
                                                formControlName="TotalPriceWithVat"
                                                appTwoDigitDecimaNumber>{{row.value.TotalPriceWithVat}}
                                                ({{currency}})</span>
                                              <span
                                                class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                                ngDefaultControl style="padding-right: 1px !important; width: 133px;"
                                                formControlName="TotalPriceQARWithVat"
                                                appTwoDigitDecimaNumber>{{formatNumber(row.value.TotalPriceQARWithVat,
                                                2)}}
                                                (QAR)</span>
                                            </td>
                                            <td>
                                              <div class="form-check text-center">
                                                <input type="checkbox" class="form-check-input "
                                                  style="margin-top: -10px;" formControlName="INST">
                                              </div>
                                            </td>
                                            <td>
                                              <div class="form-check text-center">
                                                <input type="checkbox" class="form-check-input "
                                                  style="margin-top: -10px;" formControlName="TandC">
                                              </div>
                                            </td>
                                            <td>
                                              <div class="form-check text-center">
                                                <input type="checkbox" class="form-check-input "
                                                  style="margin-top: -10px;" formControlName="HandingOver">
                                              </div>
                                            </td>
                                            <td>
                                              <div class="form-check text-center">
                                                <input type="checkbox" class="form-check-input "
                                                  style="margin-top: -10px;" formControlName="Warranty">
                                              </div>
                                            </td>
                                          </tr>
                                        </ng-container>
                                      </ng-container>
                                      <tr>
                                        <td colspan="12" class="text-right font-weight-bold">Freight Amount</td>
                                        <td>
                                          <span *ngIf="currency != 'QAR'"
                                            class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                            style="padding-right: 1px !important; width: 133px;">{{freightCharges |
                                            number : "1.2-2"}}
                                            ({{currency}})</span>
                                          <span class="d-flex justify-content-end">
                                            <input type="text" formControlName="FreightAmountQAR"
                                              class="form-control form-control-sm p-1 text-right mr-1"
                                              style="min-width: 62px; max-width: 62px"
                                              (keypress)="preventDecimalInput($event,'FreightAmountQAR')"
                                              (input)="totalsum()" /><span class="font-weight-bold">(QAR)</span>
                                          </span>
                                        </td>
                                        <td colspan="4">
                                          <textarea formControlName="FreightRemark" placeholder="Freight Remarks"
                                            class="form-control form-control-sm" maxlength="200"></textarea>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td colspan="8"></td>
                                        <td class="font-weight-bold" style=" font-size:0.8rem;">
                                          TOTAL
                                        </td>
                                        <td> <span *ngIf="currency != 'QAR'"
                                            class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                            ngDefaultControl style="padding-right: 1px !important; width: 133px; "
                                            (keyup)="getPrice(i)" type="text" appTwoDigitDecimaNumber min="1"
                                            readonly>{{formatNumber(DiscountValue, 2)}} ({{currency}})</span>
                                          <span
                                            class="form-control-plaintext p-0 mt-0 d-block text-right font-weight-bold"
                                            ngDefaultControl style="padding-right: 1px !important; width: 133px; "
                                            (keyup)="getPrice(i)" type="text" appTwoDigitDecimaNumber min="1"
                                            readonly>{{formatNumber(TotalDiscountQAR, 2)}} (QAR)</span>
                                        </td>
                                        <td> <span *ngIf="currency != 'QAR'"
                                            class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                            ngDefaultControl style="padding-right: 1px !important; width: 133px; "
                                            type="text" appTwoDigitDecimaNumber min="1"
                                            readonly>{{formatNumber(TotalQuotedSalesValue, 2)}} ({{currency}})</span>
                                          <span
                                            class="form-control-plaintext p-0 mt-0 d-block text-right font-weight-bold"
                                            ngDefaultControl style="padding-right: 1px !important; width: 133px; "
                                            type="text" appTwoDigitDecimaNumber min="1" (keyup)="getPrice(i)"
                                            readonly>{{formatNumber(TotalReportedQuotedSalesValue, 2)}} (QAR)</span>
                                        </td>
                                        <td> <span *ngIf="currency != 'QAR'"
                                            class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                            ngDefaultControl style="padding-right: 1px !important; width: 133px; "
                                            type="text" appTwoDigitDecimaNumber min="1"
                                            readonly>{{formatNumber(TotalTaxAmount, 2)}}
                                            ({{currency}})</span>
                                          <span
                                            class="form-control-plaintext p-0 mt-0 d-block text-right font-weight-bold"
                                            ngDefaultControl style="padding-right: 1px !important; width: 133px; "
                                            type="text" appTwoDigitDecimaNumber min="1" (keyup)="getPrice(i)"
                                            readonly>{{formatNumber(TotalTaxAmountQAR, 2)}} (QAR)</span>
                                        </td>
                                        <td> <span *ngIf="currency != 'QAR'"
                                            class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                            ngDefaultControl style="padding-right: 1px !important; width: 133px; "
                                            type="text" appTwoDigitDecimaNumber min="1"
                                            readonly>{{formatNumber(TotalPricewithVat,
                                            2)}} ({{currency}})</span>
                                          <span
                                            class="form-control-plaintext p-0 mt-0 d-block text-right font-weight-bold"
                                            ngDefaultControl style="padding-right: 1px !important; width: 133px; "
                                            type="text" appTwoDigitDecimaNumber min="1" (keyup)="getPrice(i)"
                                            readonly>{{formatNumber(TotalPricewithVatQAR, 2)}} (QAR)</span>
                                        </td>
                                        <td colspan="4"></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <div *ngIf="Itemdata == 0" class="text-center">
                                    No Record found.
                                  </div>
                                </div>
                                
                              </form>
                              <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-12">
                                <a href="javascript:void(0);" class="btn btn-info" (click)="onSubmit1()">Save</a>
                              </div>
                            </div>
                          </ng-template>
                        </ngb-panel>

                        <ngb-panel title="Commercial Information" class="fade">
                          <ng-template ngbPanelContent *ngIf="check >= 2 || ComInfo == true">
                            <form [formGroup]="commercialForm">
                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Inco Terms
                                    <span class="required ml-1">*</span></label>
                                  <angular2-multiselect [data]="showInco" [(ngModel)]="selectedInco"
                                    [settings]="dropdownSetting7" formControlName="IncoTerm"
                                    (onSelect)="onIncoSelect($event)" (onDeSelect)="onIncoSelect($event)" fixSearchBug>
                                  </angular2-multiselect>
                                  <div
                                    *ngIf="commercialForm.get('IncoTerm').invalid && commercialForm.get('IncoTerm').errors && (commercialForm.get('IncoTerm').dirty || commercialForm.get('IncoTerm').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="commercialForm.get('IncoTerm').hasError('required')">
                                      Inco Terms is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Mode of Shipment
                                    <span class="required ml-1">*</span></label>
                                  <angular2-multiselect [data]="Mode" formControlName="ModeOfShipment"
                                    [(ngModel)]="selectedMode" [settings]="dropdownMode"
                                    (onSelect)="onModeSelect($event)"
                                    (onDeSelect)="onModeDeSelect($event)"></angular2-multiselect>
                                  <div
                                    *ngIf="commercialForm.get('ModeOfShipment').invalid && commercialForm.get('ModeOfShipment').errors && (commercialForm.get('ModeOfShipment').dirty || commercialForm.get('ModeOfShipment').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="commercialForm.get('ModeOfShipment').hasError('required')">
                                      Mode of Shipment is Required.
                                    </small>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">SO Contract Base
                                    Value ({{orderdata.currencyName}})
                                    <span class="required ml-1">*</span></label>
                                  <input class="form-control " type="text" formControlName="SOContractBaseValue"
                                    [(ngModel)]="baseValue" appTwoDigitDecimaNumber readonly />
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">SO Reported Value (QAR)
                                    <span class="required ml-1">*</span></label>
                                  <input class="form-control " type="text" formControlName="SOReportedValue"
                                    [(ngModel)]="reportedValue" appTwoDigitDecimaNumber readonly />
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Client Payment Currency
                                    <span class="required ml-1">*</span></label>
                                  <select class="form-control" formControlName="ClientPaymentCurrency">
                                    <option value="Base">Base ({{orderdata.currencyName}})</option>
                                    <option value="Reported">Reported (QAR)</option>
                                  </select>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Advance & LC
                                    <span class="required ml-1">*</span></label>
                                  <select class="form-control" formControlName="AdvanceAndLC">
                                    <option value=true>Applicable</option>
                                    <option value=false>Not Applicable</option>
                                  </select>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="AdvanceAndLCId">
                                  <label for="" class="d-flex  align-items-center">Select
                                    <span class="required ml-1">*</span></label>
                                  <angular2-multiselect [data]="Advance" formControlName="AdvanceAndLCId"
                                    [(ngModel)]="selectedAdvance" [settings]="dropdownAdvance"
                                    (onSelect)="onAdvanceSelect($event)"
                                    [ngClass]="{'is-invalid': submitted && c.AdvanceAndLCId.errors}"
                                    (onDeSelect)="onAdvanceSelect($event)"></angular2-multiselect>
                                  <div *ngIf="submitted && c.AdvanceAndLCId.errors" class="invalid-feedback">
                                    <div *ngIf="c.AdvanceAndLCId.errors.required">Advance Select is required</div>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="ALCReceived">
                                  <label for="" class="d-flex  align-items-center">Select
                                    <span class="required ml-1">*</span></label>
                                  <angular2-multiselect [data]="AlcOption" formControlName="ALCReceived"
                                    [(ngModel)]="selectedOption" [settings]="dropdownSelect"
                                    (onSelect)="onOptionSelect($event)"
                                    [ngClass]="{'is-invalid': submitted && c.ALCReceived.errors}"
                                    (onDeSelect)="onOptionSelect($event)"></angular2-multiselect>
                                  <div *ngIf="submitted && c.ALCReceived.errors" class="invalid-feedback">
                                    <div *ngIf="c.ALCReceived.errors.required">ALC is required</div>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="LCNumber">
                                  <label for="" class="d-flex  align-items-center">LC Number
                                    <span class="required ml-1">*</span></label>
                                  <input class="form-control" formControlName="LCNumber" type="text"
                                    [ngClass]="{'is-invalid': submitted && c.LCNumber.errors}" />
                                  <div *ngIf="submitted && c.LCNumber.errors" class="invalid-feedback">
                                    <div *ngIf="c.LCNumber.errors.required">LC Number is required</div>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="LCValue">
                                  <label for="" class="d-flex align-items-center">LC Value
                                    <span class="required ml-1">*</span></label>
                                  <input class="form-control" formControlName="LCValue" type="text"
                                    [ngClass]="{'is-invalid': submitted && c.LCValue.errors}" appTwoDigitDecimaNumber
                                    (paste)="pasteNum($event)" maxlength="13" max="9999999999.99"
                                    (input)="parseNUm($event); keyPressNumeric($event)" ondrop="return false;" />
                                  <div *ngIf="submitted && c.LCValue.errors" class="invalid-feedback">
                                    <div *ngIf="c.LCValue.errors.required">LC Value is required</div>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="IssuedDate">
                                  <label for="" class="d-flex align-items-center">Issued Date
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="bg-calender-icon form-control"
                                      formControlName="IssuedDate" id="inlineFormInputGroup" placeholder="DD-MM-YYYY"
                                      bsDatepicker [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
                                      [ngClass]="{ 'is-invalid': submitted && c.IssuedDate.errors}"
                                      (keydown)="disableDate()" autocomplete="off">
                                    <div *ngIf="submitted && c.IssuedDate.errors" class="invalid-feedback">
                                      <div *ngIf="c.IssuedDate.errors.required">IssuedDate is required</div>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="ExpiryDate">
                                  <label for="" class="d-flex align-items-center">Expiry Date
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="bg-calender-icon form-control"
                                      formControlName="ExpiryDate" id="inlineFormInputGroup" placeholder="DD-MM-YYYY"
                                      bsDatepicker [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
                                      [ngClass]="{ 'is-invalid': submitted && c.ExpiryDate.errors}"
                                      (keydown)="disableDate()" autocomplete="off">
                                    <div *ngIf="submitted && c.ExpiryDate.errors" class="invalid-feedback">
                                      <div *ngIf="c.ExpiryDate.errors.required">ExpiryDate is required</div>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="ExpectedDate">
                                  <label for="" class="d-flex align-items-center">Expected Date
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="bg-calender-icon form-control"
                                      formControlName="ExpectedDate" id="inlineFormInputGroup" placeholder="DD-MM-YYYY"
                                      bsDatepicker [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
                                      [ngClass]="{ 'is-invalid': submitted && c.ExpectedDate.errors}"
                                      (keydown)="disableDate()" autocomplete="off">
                                    <div *ngIf="submitted && c.ExpectedDate.errors" class="invalid-feedback">
                                      <div *ngIf="c.ExpectedDate.errors.required">ExpectedDate is required</div>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="AdvanceAmt">
                                  <label for="" class="d-flex align-items-center">Advance Amount
                                    <span
                                      *ngIf="c.ClientPaymentCurrency?.value === 'Base'">&nbsp;({{orderdata.currencyName}})</span>
                                    <span *ngIf="c.ClientPaymentCurrency?.value === 'Reported'">&nbsp;(QAR)</span>
                                    <span class="required ml-1">*</span></label>
                                  <input class="form-control" formControlName="AdvanceAmt" type="text"
                                    appTwoDigitDecimaNumber [ngClass]="{'is-invalid': submitted && c.AdvanceAmt.errors}"
                                    (paste)="pasteNumbr($event)" maxlength="13" max="9999999999.99"
                                    (input)="parseNUm($event); keyPressNumeric($event)" ondrop="return false;" />
                                  <div *ngIf="submitted && c.AdvanceAmt.errors" class="invalid-feedback">
                                    <div *ngIf="c.AdvanceAmt.errors.required">Advance Amount is required</div>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="ReceivedDate">
                                  <label for="" class="d-flex align-items-center">Received Date
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="bg-calender-icon form-control"
                                      [minDate]="InquiryReceivedDate" formControlName="ReceivedDate"
                                      id="inlineFormInputGroup" placeholder="DD-MM-YYYY" bsDatepicker
                                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
                                      [ngClass]="{ 'is-invalid': submitted && c.ReceivedDate.errors}"
                                      (keydown)="disableDate()" autocomplete="off">
                                    <div *ngIf="submitted && c.ReceivedDate.errors" class="invalid-feedback">
                                      <div *ngIf="c.ReceivedDate.errors.required">ReceivedDate is required</div>
                                    </div>
                                  </div>
                                </div>

                              </div>

                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Project Margin (%) <span
                                      class="required ml-1">*</span></label>
                                  <input class="form-control" formControlName="ProjectMargin" type="text"
                                    appTwoDigitDecimaNumber (input)="modeP($event)" />
                                  <div
                                    *ngIf="commercialForm.get('ProjectMargin').invalid && commercialForm.get('ProjectMargin').errors && (commercialForm.get('ProjectMargin').dirty || commercialForm.get('ProjectMargin').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="commercialForm.get('ProjectMargin').hasError('required')">
                                      Project Margin is Required.
                                    </small>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex align-items-center">Project Start Date
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="bg-calender-icon form-control"
                                      formControlName="ProjectStartDate" id="inlineFormInputGroup"
                                      placeholder="DD-MM-YYYY" bsDatepicker [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
                                      (ngModelChange)="newFunc1($event)" [minDate]="InquiryReceivedDate"
                                      [maxDate]="maxStartDate" (keydown)="disableDate()" autocomplete="off">
                                  </div>
                                  <div
                                    *ngIf="commercialForm.get('ProjectStartDate').invalid && commercialForm.get('ProjectStartDate').errors && (commercialForm.get('ProjectStartDate').dirty || commercialForm.get('ProjectStartDate').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="commercialForm.get('ProjectStartDate').hasError('required')">
                                      Project Start Date is Required.
                                    </small>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex align-items-center">Project Completion Date
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="bg-calender-icon form-control"
                                      formControlName="ProjectCompletionDate" id="inlineFormInputGroup"
                                      placeholder="DD-MM-YYYY" bsDatepicker [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
                                      [minDate]="maxProjDate" (ngModelChange)="newFunc($event)"
                                      (keydown)="disableDate()" autocomplete="off">
                                  </div>
                                  <div
                                    *ngIf="commercialForm.get('ProjectCompletionDate').invalid && commercialForm.get('ProjectCompletionDate').errors && (commercialForm.get('ProjectCompletionDate').dirty || commercialForm.get('ProjectCompletionDate').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="commercialForm.get('ProjectCompletionDate').hasError('required')">
                                      Project Completion Date is Required.
                                    </small>
                                  </div>
                                </div>
                              </div>

                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Credit Split
                                    <span class="required ml-1">*</span>
                                    <span
                                      class="mdi mdi-plus mdi-18px cursor-pointer ml-2 btn btn-sm rounded-0 btn-info btn-min-width p-0"
                                      title="Add Credit" *ngIf="commercialForm.value.CreditSplit !== 'false'"
                                      (click)="addCredit()"></span>
                                  </label>
                                  <select class="form-control" formControlName="CreditSplit"
                                    (change)="creditMode($event.target.value)">
                                    <option value="true">Applicable</option>
                                    <option value="false">Not Applicable</option>
                                  </select>
                                </div>

                                <!-- <div class="form-group col-lg-3 col-md-6 col-sm-12"
                                  *ngIf="commercialForm.value.CreditSplit !== 'false'">
                                  <label for="" class="d-flex  align-items-center">&nbsp; </label>
                                  <a href="javascript:void(0)" class="btn btn-info text-white" (click)="addCredit()">
                                    <span class="mdi mdi-plus"></span>Add Credit
                                  </a>
                                </div> -->
                              </div>

                              <ng-container *ngIf="advancePaidStatus5">
                                <div formArrayName="ObjOrderCredit" *ngFor="let t of ObjOrderCredit1; let i = index">
                                  <div class="form-row" [formGroupName]="i"
                                    *ngIf="t.controls.Status.value==1 || t.controls.Status.value==undefined">
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                      <label for="" class="d-flex  align-items-center">Credit Split (%)
                                        <span class="required ml-1">*</span>
                                        <a href="javascript:void(0);"
                                          class="btn-link ml-2 align-items-center d-flex justify-content-center text-danger"
                                          (click)="onDeleteCredit(i)" ngbTooltip="Delete">
                                          <span class="fa fa-trash"></span>
                                        </a>
                                      </label>
                                      <input class="form-control" formControlName="CreditSplitPercentage" type="text"
                                        id="{{'CreditSplitPercentage'+ i}}"
                                        (keypress)="percentValidate($event, i,'CreditSplitPercentage')"
                                        [ngClass]="{ 'is-invalid': submitted && t.get('CreditSplitPercentage').errors}" />
                                      <div
                                        *ngIf="submitted && t.get('CreditSplitPercentage').hasError('required') && t.get('CreditSplitPercentage').errors"
                                        class="invalid-feedback">
                                        <span style="color:red !important; font-size: 12px;">
                                          Credit Split % is required</span>
                                      </div>
                                    </div>
                                    <div>
                                      <input type="text" class="form-control" formControlName="Status"
                                        [(ngModel)]="rowvalue[i]" hidden />
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                      <label for="" class="d-flex  align-items-center">Credit Person Name
                                        <span class="required ml-1">*</span></label>
                                      <ng-select [items]="credit" bindValue="id" bindLabel="itemName"
                                        formControlName="CreditPerson" [(ngModel)]="selectedCredit[i]"
                                        placeholder="Select Credit Person"
                                        [ngClass]="{ 'is-invalid': submitted && t.get('CreditPerson').errors}">
                                      </ng-select>
                                      <div
                                        *ngIf="submitted && t.get('CreditPerson').hasError('required') && t.get('CreditPerson').errors"
                                        class="invalid-feedback">
                                        <span style="color:red !important; font-size: 12px;">
                                          Credit Person is required</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>

                              <div class="row mb-3">
                                <div class="col-lg-12">
                                  <a href="javascript:void(0);" class="btn btn-info" (click)="onSubmit2()">Save</a>
                                </div>
                              </div>
                            </form>
                            <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                          </ng-template>
                        </ngb-panel>

                        <ngb-panel title="Payment Terms" class="fade">
                          <ng-template ngbPanelContent *ngIf="check >= 3 || PayTerm == true">
                            <form [formGroup]="PaymentTermInfo">
                              <div class="table-responsive mb-3">
                                <table class="table hover table-striped table-bordered p-1" aria-hidden="true">
                                  <thead>
                                    <tr>
                                      <th style="text-align:left;">Check Box </th>
                                      <th style="min-width:190px;">Payment Terms Type</th>
                                      <th style="min-width:120px;">Base Value</th>
                                      <th style="min-width:160px;">Reported Value</th>
                                      <th style="min-width:135px;">% (Reported Value)</th>
                                      <th style="min-width:120px;">Credit Days</th>
                                      <th style="min-width:165px;">Mode Of Payment</th>
                                      <th style="min-width:180px;">Payment Remarks</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <ng-container formGroupName='Advance'>
                                        <td>
                                          <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" value="true"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">Yes</label>
                                            &nbsp; &nbsp;
                                            <input class="form-check-input" type="radio" value="false"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">No</label>
                                          </div>
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="PaymentTermType"
                                            readonly hidden>Advance
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="BaseValue"
                                            [(ngModel)]="baseValue1" readonly>
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="ReportedValue"
                                            [(ngModel)]="reportedValue1" readonly></td>
                                        <td><input type="text" class="form-control" formControlName="ReportedValuePer"
                                            (keyup)="calculatePercentage()" maxlength="6" max="100"
                                            appTwoDigitDecimaNumber
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('Advance.ReportedValuePer').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('Advance.ReportedValuePer').errors"
                                            class="invalid-feedback">
                                            <div
                                              *ngIf="PaymentTermInfo.get('Advance.ReportedValuePer').errors.required">
                                              Reported Value % is required</div>
                                          </div>
                                        </td>
                                        <td><input type="text" class="form-control" formControlName="CreditDays"
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('Advance.CreditDays').errors}">
                                          <div *ngIf="submitted && PaymentTermInfo.get('Advance.CreditDays').errors"
                                            class="invalid-feedback">
                                            <div *ngIf="PaymentTermInfo.get('Advance.CreditDays').errors.required">
                                              Credit Days is required</div>
                                          </div>
                                        </td>

                                        <td>
                                          <ng-select [items]="modePay" bindValue="id" bindLabel="itemName"
                                            formControlName="ModeOfPayment" [(ngModel)]="selectedPayment"
                                            placeholder="Select Payment" class="wrap-text"
                                            [ngClass]="{ 'is-invalid': submitted && PaymentTermInfo.get('Advance.ModeOfPayment').errors}">
                                          </ng-select>
                                          <div *ngIf="submitted && 
                                          PaymentTermInfo.get('Advance.ModeOfPayment').errors"
                                            class="invalid-feedback">
                                            <span style="color:red !important; font-size: 12px;">
                                              Payment is required</span>
                                          </div>
                                        </td>

                                        <td><textarea class="form-control" formControlName="PaymentRemark"></textarea>
                                        </td>

                                      </ng-container>
                                    </tr>
                                    <tr>
                                      <ng-container formGroupName='AgainstDelivery'>
                                        <td>
                                          <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" value="true"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">Yes</label>
                                            &nbsp; &nbsp;
                                            <input class="form-check-input" type="radio" value="false"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">No</label>
                                          </div>
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="PaymentTermType"
                                            readonly hidden>Against Delivery
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="BaseValue"
                                            [(ngModel)]="baseValue2" readonly>
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="ReportedValue"
                                            [(ngModel)]="reportedValue2" readonly>
                                        </td>
                                        <td><input type="text" class="form-control" formControlName="ReportedValuePer"
                                            (keyup)="calculatePercentage()" maxlength="6" max="100"
                                            appTwoDigitDecimaNumber
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('AgainstDelivery.ReportedValuePer').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('AgainstDelivery.ReportedValuePer').errors"
                                            class="invalid-feedback">
                                            <div
                                              *ngIf="PaymentTermInfo.get('AgainstDelivery.ReportedValuePer').errors.required">
                                              Reported Value % is required</div>
                                          </div>
                                        </td>
                                        <td><input type="text" class="form-control" formControlName="CreditDays"
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('AgainstDelivery.CreditDays').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('AgainstDelivery.CreditDays').errors"
                                            class="invalid-feedback">
                                            <div
                                              *ngIf="PaymentTermInfo.get('AgainstDelivery.CreditDays').errors.required">
                                              Credit Days is required</div>
                                          </div>
                                        </td>

                                        <td>
                                          <ng-select [items]="modePay" bindValue="id" bindLabel="itemName"
                                            formControlName="ModeOfPayment" [(ngModel)]="selectedPayment1"
                                            placeholder="Select Payment" class="wrap-text"
                                            [ngClass]="{ 'is-invalid': submitted && PaymentTermInfo.get('AgainstDelivery.ModeOfPayment').errors}">
                                          </ng-select>
                                          <div *ngIf="submitted && 
                                          PaymentTermInfo.get('AgainstDelivery.ModeOfPayment').errors"
                                            class="invalid-feedback">
                                            <span style="color:red !important; font-size: 12px;">
                                              Payment is required</span>
                                          </div>
                                        </td>

                                        <td><textarea class="form-control" formControlName="PaymentRemark"></textarea>
                                        </td>
                                      </ng-container>
                                    </tr>
                                    <tr>
                                      <ng-container formGroupName='AgainstInstallation'>
                                        <td>
                                          <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" value="true"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">Yes</label>
                                            &nbsp; &nbsp;
                                            <input class="form-check-input" type="radio" value="false"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">No</label>
                                          </div>
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="PaymentTermType"
                                            readonly hidden>Against
                                          Installation</td>
                                        <td><input class="form-control-plaintext" formControlName="BaseValue" readonly
                                            [(ngModel)]="baseValue3"></td>
                                        <td><input class="form-control-plaintext" formControlName="ReportedValue"
                                            [(ngModel)]="reportedValue3" readonly></td>
                                        <td><input type="text" class="form-control" formControlName="ReportedValuePer"
                                            (keyup)="calculatePercentage()" maxlength="6" max="100"
                                            appTwoDigitDecimaNumber
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('AgainstInstallation.ReportedValuePer').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('AgainstInstallation.ReportedValuePer').errors"
                                            class="invalid-feedback">
                                            <div
                                              *ngIf="PaymentTermInfo.get('AgainstInstallation.ReportedValuePer').errors.required">
                                              Reported Value % is required</div>
                                          </div>
                                        </td>
                                        <td><input type="text" class="form-control" formControlName="CreditDays"
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('AgainstInstallation.CreditDays').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('AgainstInstallation.CreditDays').errors"
                                            class="invalid-feedback">
                                            <div
                                              *ngIf="PaymentTermInfo.get('AgainstInstallation.CreditDays').errors.required">
                                              Credit Days is required</div>
                                          </div>
                                        </td>

                                        <td>
                                          <ng-select [items]="modePay" bindValue="id" bindLabel="itemName"
                                            formControlName="ModeOfPayment" [(ngModel)]="selectedPayment2"
                                            placeholder="Select Payment" class="wrap-text"
                                            [ngClass]="{ 'is-invalid': submitted && PaymentTermInfo.get('AgainstInstallation.ModeOfPayment').errors}">
                                          </ng-select>
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('AgainstInstallation.ModeOfPayment').errors"
                                            class="invalid-feedback">
                                            <span style="color:red !important; font-size: 12px;">
                                              Payment is required</span>
                                          </div>
                                        </td>

                                        <td><textarea class="form-control" formControlName="PaymentRemark"></textarea>
                                        </td>
                                      </ng-container>
                                    </tr>
                                    <tr>
                                      <ng-container formGroupName='AgainstTestingandCommissioning'>
                                        <td>
                                          <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" value="true"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">Yes</label>
                                            &nbsp; &nbsp;
                                            <input class="form-check-input" type="radio" value="false"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">No</label>
                                          </div>
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="PaymentTermType"
                                            readonly hidden>Against Testing
                                          and Commissioning</td>
                                        <td><input class="form-control-plaintext" formControlName="BaseValue" readonly
                                            [(ngModel)]="baseValue4"></td>
                                        <td><input class="form-control-plaintext" formControlName="ReportedValue"
                                            [(ngModel)]="reportedValue4" readonly></td>
                                        <td><input type="text" class="form-control" formControlName="ReportedValuePer"
                                            (keyup)="calculatePercentage()" maxlength="6" max="100"
                                            appTwoDigitDecimaNumber
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('AgainstTestingandCommissioning.ReportedValuePer').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('AgainstTestingandCommissioning.ReportedValuePer').errors"
                                            class="invalid-feedback">
                                            <div
                                              *ngIf="PaymentTermInfo.get('AgainstTestingandCommissioning.ReportedValuePer').errors.required">
                                              Reported Value % is required</div>
                                          </div>
                                        </td>
                                        <td><input type="text" class="form-control" formControlName="CreditDays"
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('AgainstTestingandCommissioning.CreditDays').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('AgainstTestingandCommissioning.CreditDays').errors"
                                            class="invalid-feedback">
                                            <div
                                              *ngIf="PaymentTermInfo.get('AgainstTestingandCommissioning.CreditDays').errors.required">
                                              Credit Days is required</div>
                                          </div>
                                        </td>

                                        <td>
                                          <ng-select [items]="modePay" bindValue="id" bindLabel="itemName"
                                            formControlName="ModeOfPayment" [(ngModel)]="selectedPayment3"
                                            placeholder="Select Payment" class="wrap-text"
                                            [ngClass]="{ 'is-invalid': submitted && PaymentTermInfo.get('AgainstTestingandCommissioning.ModeOfPayment').errors}">
                                          </ng-select>
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('AgainstTestingandCommissioning.ModeOfPayment').errors"
                                            class="invalid-feedback">
                                            <span style="color:red !important; font-size: 12px;">
                                              Payment is required</span>
                                          </div>
                                        </td>

                                        <td><textarea class="form-control" formControlName="PaymentRemark"></textarea>
                                        </td>
                                      </ng-container>
                                    </tr>
                                    <tr>
                                      <ng-container formGroupName='Againsthandingover'>
                                        <td>
                                          <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" value="true"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">Yes</label>
                                            &nbsp; &nbsp;
                                            <input class="form-check-input" type="radio" value="false"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">No</label>
                                          </div>
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="PaymentTermType"
                                            readonly hidden>Against handing
                                          over</td>
                                        <td><input class="form-control-plaintext" formControlName="BaseValue" readonly
                                            [(ngModel)]="baseValue5"></td>
                                        <td><input class="form-control-plaintext" formControlName="ReportedValue"
                                            [(ngModel)]="reportedValue5" readonly></td>
                                        <td><input type="text" class="form-control" formControlName="ReportedValuePer"
                                            (keyup)="calculatePercentage()" maxlength="6" max="100"
                                            appTwoDigitDecimaNumber
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('Againsthandingover.ReportedValuePer').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('Againsthandingover.ReportedValuePer').errors"
                                            class="invalid-feedback">
                                            <div
                                              *ngIf="PaymentTermInfo.get('Againsthandingover.ReportedValuePer').errors.required">
                                              Reported Value % is required</div>
                                          </div>
                                        </td>
                                        <td><input type="text" class="form-control" formControlName="CreditDays"
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('Againsthandingover.CreditDays').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('Againsthandingover.CreditDays').errors"
                                            class="invalid-feedback">
                                            <div
                                              *ngIf="PaymentTermInfo.get('Againsthandingover.CreditDays').errors.required">
                                              Credit Days is required</div>
                                          </div>
                                        </td>

                                        <td>
                                          <ng-select [items]="modePay" bindValue="id" bindLabel="itemName"
                                            formControlName="ModeOfPayment" [(ngModel)]="selectedPayment4"
                                            placeholder="Select Payment" class="wrap-text"
                                            [ngClass]="{ 'is-invalid': submitted && PaymentTermInfo.get('Againsthandingover.ModeOfPayment').errors}">
                                          </ng-select>
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('Againsthandingover.ModeOfPayment').errors"
                                            class="invalid-feedback">
                                            <span style="color:red !important; font-size: 12px;">
                                              Payment is required</span>
                                          </div>
                                        </td>

                                        <td><textarea class="form-control" formControlName="PaymentRemark"></textarea>
                                        </td>
                                      </ng-container>
                                    </tr>
                                    <tr>
                                      <ng-container formGroupName='AfterDLP'>
                                        <td>
                                          <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" value="true"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">Yes</label>
                                            &nbsp; &nbsp;
                                            <input class="form-check-input" type="radio" value="false"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">No</label>
                                          </div>
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="PaymentTermType"
                                            readonly hidden>After DLP</td>

                                        <td><input class="form-control-plaintext" formControlName="BaseValue" readonly
                                            [(ngModel)]="baseValue6"></td>

                                        <td><input class="form-control-plaintext" formControlName="ReportedValue"
                                            [(ngModel)]="reportedValue6" readonly></td>

                                        <td><input type="text" class="form-control" formControlName="ReportedValuePer"
                                            (keyup)="calculatePercentage()" maxlength="6" max="100"
                                            appTwoDigitDecimaNumber
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('AfterDLP.ReportedValuePer').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('AfterDLP.ReportedValuePer').errors"
                                            class="invalid-feedback">
                                            <div
                                              *ngIf="PaymentTermInfo.get('AfterDLP.ReportedValuePer').errors.required">
                                              Reported Value % is required</div>
                                          </div>
                                        </td>

                                        <td><input type="text" class="form-control" formControlName="CreditDays"
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('AfterDLP.CreditDays').errors}">
                                          <div *ngIf="submitted && PaymentTermInfo.get('AfterDLP.CreditDays').errors"
                                            class="invalid-feedback">
                                            <div *ngIf="PaymentTermInfo.get('AfterDLP.CreditDays').errors.required">
                                              Credit Days is required</div>
                                          </div>
                                        </td>

                                        <td>
                                          <ng-select [items]="modePay" bindValue="id" bindLabel="itemName"
                                            formControlName="ModeOfPayment" [(ngModel)]="selectedPayment5"
                                            placeholder="Select Payment" class="wrap-text"
                                            [ngClass]="{ 'is-invalid': submitted && PaymentTermInfo.get('AfterDLP.ModeOfPayment').errors}">
                                          </ng-select>
                                          <div *ngIf="submitted && PaymentTermInfo.get('AfterDLP.ModeOfPayment').errors"
                                            class="invalid-feedback">
                                            <span style="color:red !important; font-size: 12px;">
                                              Payment is required</span>
                                          </div>
                                        </td>

                                        <td><textarea class="form-control" formControlName="PaymentRemark"></textarea>
                                        </td>

                                      </ng-container>
                                    </tr>
                                    <tr>
                                      <ng-container formGroupName='AgainsttoRepairService'>
                                        <td>
                                          <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" value="true"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">Yes</label>
                                            &nbsp; &nbsp;
                                            <input class="form-check-input" type="radio" value="false"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">No</label>
                                          </div>
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="PaymentTermType"
                                            readonly hidden>Against to
                                          Repair / Service</td>
                                        <td><input class="form-control-plaintext" formControlName="BaseValue" readonly
                                            [(ngModel)]="baseValue7"></td>
                                        <td><input class="form-control-plaintext" formControlName="ReportedValue"
                                            [(ngModel)]="reportedValue7" readonly></td>
                                        <td><input type="text" class="form-control" formControlName="ReportedValuePer"
                                            (keyup)="calculatePercentage()" maxlength="6" max="100"
                                            appTwoDigitDecimaNumber
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('AgainsttoRepairService.ReportedValuePer').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('AgainsttoRepairService.ReportedValuePer').errors"
                                            class="invalid-feedback">
                                            <div
                                              *ngIf="PaymentTermInfo.get('AgainsttoRepairService.ReportedValuePer').errors.required">
                                              Reported Value % is required</div>
                                          </div>
                                        </td>

                                        <td><input type="text" class="form-control" formControlName="CreditDays"
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('AgainsttoRepairService.CreditDays').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('AgainsttoRepairService.CreditDays').errors"
                                            class="invalid-feedback">
                                            <div
                                              *ngIf="PaymentTermInfo.get('AgainsttoRepairService.CreditDays').errors.required">
                                              Credit Days is required</div>
                                          </div>
                                        </td>

                                        <td>
                                          <ng-select [items]="modePay" bindValue="id" bindLabel="itemName"
                                            formControlName="ModeOfPayment" [(ngModel)]="selectedPayment6"
                                            placeholder="Select Payment" class="wrap-text"
                                            [ngClass]="{ 'is-invalid': submitted && PaymentTermInfo.get('AgainsttoRepairService.ModeOfPayment').errors}">
                                          </ng-select>
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('AgainsttoRepairService.ModeOfPayment').errors"
                                            class="invalid-feedback">
                                            <span style="color:red !important; font-size: 12px;">
                                              Payment is required</span>
                                          </div>
                                        </td>

                                        <td><textarea class="form-control" formControlName="PaymentRemark"></textarea>
                                        </td>
                                      </ng-container>
                                    </tr>
                                    <tr>
                                      <ng-container formGroupName='Other1'>
                                        <td>
                                          <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" value="true"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">Yes</label>
                                            &nbsp; &nbsp;
                                            <input class="form-check-input" type="radio" value="false"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">No</label>
                                          </div>
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="PaymentTermType"
                                            readonly hidden>Other 1</td>
                                        <td><input class="form-control-plaintext" formControlName="BaseValue" readonly
                                            [(ngModel)]="baseValue8"></td>
                                        <td><input class="form-control-plaintext" formControlName="ReportedValue"
                                            [(ngModel)]="reportedValue8" readonly></td>
                                        <td><input type="text" class="form-control" formControlName="ReportedValuePer"
                                            (keyup)="calculatePercentage()" maxlength="6" max="100"
                                            appTwoDigitDecimaNumber
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('Other1.ReportedValuePer').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('Other1.ReportedValuePer').errors"
                                            class="invalid-feedback">
                                            <div *ngIf="PaymentTermInfo.get('Other1.ReportedValuePer').errors.required">
                                              Reported Value % is required</div>
                                          </div>
                                        </td>

                                        <td><input type="text" class="form-control" formControlName="CreditDays"
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('Other1.CreditDays').errors}">
                                          <div *ngIf="submitted && PaymentTermInfo.get('Other1.CreditDays').errors"
                                            class="invalid-feedback">
                                            <div *ngIf="PaymentTermInfo.get('Other1.CreditDays').errors.required">
                                              Credit Days is required</div>
                                          </div>
                                        </td>

                                        <td>
                                          <ng-select [items]="modePay" bindValue="id" bindLabel="itemName"
                                            formControlName="ModeOfPayment" [(ngModel)]="selectedPayment7"
                                            placeholder="Select Payment" class="wrap-text"
                                            [ngClass]="{ 'is-invalid': submitted && PaymentTermInfo.get('Other1.ModeOfPayment').errors}">
                                          </ng-select>
                                          <div *ngIf="submitted && PaymentTermInfo.get('Other1.ModeOfPayment').errors"
                                            class="invalid-feedback">
                                            <span style="color:red !important; font-size: 12px;">
                                              Payment is required</span>
                                          </div>
                                        </td>

                                        <td><textarea class="form-control" formControlName="PaymentRemark"></textarea>
                                        </td>
                                      </ng-container>
                                    </tr>
                                    <tr>
                                      <ng-container formGroupName='Other2'>
                                        <td>
                                          <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" value="true"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">Yes</label>
                                            &nbsp; &nbsp;
                                            <input class="form-check-input" type="radio" value="false"
                                              formControlName="PayRadioCheck">
                                            <label class="form-check-label">No</label>
                                          </div>
                                        </td>
                                        <td><input class="form-control-plaintext" formControlName="PaymentTermType"
                                            readonly hidden>Other 2</td>
                                        <td><input class="form-control-plaintext" formControlName="BaseValue" readonly
                                            [(ngModel)]="baseValue9"></td>
                                        <td><input class="form-control-plaintext" formControlName="ReportedValue"
                                            [(ngModel)]="reportedValue9" readonly></td>
                                        <td><input type="text" class="form-control" formControlName="ReportedValuePer"
                                            (keyup)="calculatePercentage()" maxlength="6" max="100"
                                            appTwoDigitDecimaNumber
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('Other2.ReportedValuePer').errors}">
                                          <div
                                            *ngIf="submitted && PaymentTermInfo.get('Other2.ReportedValuePer').errors"
                                            class="invalid-feedback">
                                            <div *ngIf="PaymentTermInfo.get('Other2.ReportedValuePer').errors.required">
                                              Reported Value % is required</div>
                                          </div>
                                        </td>

                                        <td><input type="text" class="form-control" formControlName="CreditDays"
                                            [ngClass]="{'is-invalid': submitted && PaymentTermInfo.get('Other2.CreditDays').errors}">
                                          <div *ngIf="submitted && PaymentTermInfo.get('Other2.CreditDays').errors"
                                            class="invalid-feedback">
                                            <div *ngIf="PaymentTermInfo.get('Other2.CreditDays').errors.required">
                                              Credit Days is required</div>
                                          </div>
                                        </td>

                                        <td>
                                          <ng-select [items]="modePay" bindValue="id" bindLabel="itemName"
                                            formControlName="ModeOfPayment" [(ngModel)]="selectedPayment8"
                                            placeholder="Select Payment" class="wrap-text"
                                            [ngClass]="{ 'is-invalid': submitted && PaymentTermInfo.get('Other2.ModeOfPayment').errors}">
                                          </ng-select>
                                          <div *ngIf="submitted && PaymentTermInfo.get('Other2.ModeOfPayment').errors"
                                            class="invalid-feedback">
                                            <span style="color:red !important; font-size: 12px;">
                                              Payment is required</span>
                                          </div>
                                        </td>

                                        <td><textarea class="form-control" formControlName="PaymentRemark"></textarea>
                                        </td>
                                      </ng-container>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                              <div class="form-row">

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="soOption == 'Cash Only'">
                                  <label for="" class="d-flex align-items-center">Client Registration form is it
                                    Required<span class="required ml-1">*</span>
                                  </label>
                                  <input class="form-control" type="text" [(ngModel)]="selectedClientRcName"
                                    formControlName="ClientRegistration" placeholder="{{selectedClientRcName}}"
                                    readonly />
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="soOption != 'Cash Only'">
                                  <label for="" class="d-flex  align-items-center">Client Registration form is it
                                    Required<span class="required ml-1">*</span>
                                  </label>
                                  <angular2-multiselect [data]="Client" formControlName="ClientRegistration"
                                    [(ngModel)]="selectedClientRc" [settings]="dropdownCl"
                                    (onSelect)="onClientRcSelect($event)"
                                    (onDeSelect)="onClientRcSelect($event)"></angular2-multiselect>
                                  <div
                                    *ngIf="PaymentTermInfo.get('ClientRegistration').invalid && PaymentTermInfo.get('ClientRegistration').errors && (PaymentTermInfo.get('ClientRegistration').dirty || PaymentTermInfo.get('ClientRegistration').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="PaymentTermInfo.get('ClientRegistration').hasError('required')">
                                      Client Registration is Required.
                                    </small>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="PayReceivedDate">
                                  <label for="" class="d-flex align-items-center">Received Date
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="bg-calender-icon form-control" id="inlineFormInputGroup"
                                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}" placeholder="DD-MM-YYYY" bsDatepicker
                                      formControlName="ReceivedDate" (keydown)="disableDate()" autocomplete="off"
                                      [ngClass]="{ 'is-invalid': submitted && p.ReceivedDate.errors}">
                                    <div *ngIf="submitted && p.ReceivedDate.errors" class="invalid-feedback">
                                      <div *ngIf="p.ReceivedDate.errors.required">Received Date is required</div>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="PayExpectedDate">
                                  <label for="" class="d-flex align-items-center">Expected Date
                                    <span class="required ml-1">*</span></label>
                                  <div class="input-group">
                                    <input type="text" class="bg-calender-icon form-control" id="inlineFormInputGroup"
                                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}" placeholder="DD-MM-YYYY" bsDatepicker
                                      formControlName="ExpectedDate" autocomplete="off"
                                      [ngClass]="{ 'is-invalid': submitted && p.ExpectedDate.errors}">
                                    <div *ngIf="submitted && p.ExpectedDate.errors" class="invalid-feedback">
                                      <div *ngIf="p.ExpectedDate.errors.required">Expected Date is required</div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Warranty
                                    <span class="required ml-1">*</span></label>
                                  <select class="form-control" formControlName="Warranty"
                                    (change)="modo1($event.target.value)">
                                    <option value="true">Applicable</option>
                                    <option value="false">Not Applicable</option>
                                  </select>
                                </div>

                                <div class="form-group col-lg-12 col-md-12 col-sm-12" *ngIf="advancePaidStatus1">
                                  <div class="table-responsive">
                                    <table class="table hover table-striped table-bordered mb-0" aria-hidden="true">
                                      <thead>
                                        <tr>
                                          <th>Warranty Start Date </th>
                                          <th>Whole Unit Warranty </th>
                                          <th>Parts Warranty </th>
                                          <th>Remarks </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <ng-container formGroupName='FromDelivery'>
                                            <td><input class="form-control-plaintext"
                                                formControlName="WarrantyStartDate" readonly hidden>From
                                              Delivery</td>
                                            <td><input type="text" class="form-control" maxlength="50"
                                                formControlName="WholeUnitWarranty" placeholder="365 Days">
                                            </td>
                                            <td><input type="text" class="form-control" placeholder="5 Years Compressor"
                                                formControlName="PartsWarranty" maxlength="50"></td>
                                            <td><textarea class="form-control" formControlName="Remark"
                                                maxlength="200"></textarea></td>
                                          </ng-container>
                                        </tr>
                                        <tr>
                                          <ng-container formGroupName='FromStartupCommissioning'>
                                            <td><input class="form-control-plaintext"
                                                formControlName="WarrantyStartDate" readonly hidden>From
                                              Start-up & Commissioning</td>
                                            <td><input type="text" class="form-control" maxlength="50"
                                                formControlName="WholeUnitWarranty" placeholder="365 Days">
                                            </td>
                                            <td><input type="text" class="form-control" placeholder="5 Years Compressor"
                                                formControlName="PartsWarranty" maxlength="50"></td>
                                            <td><textarea class="form-control" formControlName="Remark"
                                                maxlength="200"></textarea></td>
                                          </ng-container>
                                        </tr>
                                        <tr>
                                          <ng-container formGroupName='FromInstallation'>
                                            <td><input class="form-control-plaintext"
                                                formControlName="WarrantyStartDate" readonly hidden>From
                                              Installation</td>
                                            <td><input type="text" class="form-control" maxlength="50"
                                                formControlName="WholeUnitWarranty" placeholder="365 Days">
                                            </td>
                                            <td><input type="text" class="form-control" placeholder="5 Years Compressor"
                                                formControlName="PartsWarranty" maxlength="50"></td>
                                            <td><textarea class="form-control" formControlName="Remark"
                                                maxlength="200"></textarea></td>
                                          </ng-container>
                                        </tr>
                                        <tr>
                                          <ng-container formGroupName='FromHandingOver'>
                                            <td><input class="form-control-plaintext"
                                                formControlName="WarrantyStartDate" readonly hidden>From
                                              Handing Over</td>
                                            <td><input type="text" class="form-control" maxlength="50"
                                                formControlName="WholeUnitWarranty" placeholder="365 Days">
                                            </td>
                                            <td><input type="text" class="form-control" placeholder="5 Years Compressor"
                                                formControlName="PartsWarranty" maxlength="50"></td>
                                            <td><textarea class="form-control" formControlName="Remark"
                                                maxlength="200"></textarea></td>
                                          </ng-container>
                                        </tr>
                                        <tr>
                                          <ng-container formGroupName='EitherDeliveryStartupCommissioning'>
                                            <td><input class="form-control-plaintext"
                                                formControlName="WarrantyStartDate" readonly hidden>Either
                                              Delivery / Start-up & Commissioning</td>
                                            <td><input type="text" class="form-control" maxlength="50"
                                                formControlName="WholeUnitWarranty" placeholder="365 Days">
                                            </td>
                                            <td><input type="text" class="form-control" placeholder="5 Years Compressor"
                                                formControlName="PartsWarranty" maxlength="50"></td>
                                            <td><textarea class="form-control" formControlName="Remark"
                                                maxlength="200"></textarea></td>
                                          </ng-container>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>

                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Supplier PO
                                    <span class="required ml-1">*</span>
                                    <span
                                      class="mdi mdi-plus mdi-18px cursor-pointer ml-2 btn btn-sm rounded-0 btn-info btn-min-width p-0"
                                      title="Add Supplier" *ngIf="PaymentTermInfo.value.SupplierPO != 'false'"
                                      (click)="addTicket()"></span>
                                  </label>
                                  <select class="form-control" formControlName="SupplierPO"
                                    (change)="supplierMode($event.target.value)">
                                    <option value="true">Applicable</option>
                                    <option value="false">Not Applicable</option>
                                  </select>
                                </div>
                                <!-- <div class="form-group col-lg-3 col-md-6 col-sm-12"
                                  *ngIf="PaymentTermInfo.value.SupplierPO !== 'false'">
                                  <label for="" class="d-flex  align-items-center">&nbsp; </label>
                                  <a href="javascript:void(0)" class="btn btn-info text-white" (click)="addTicket()">
                                    <span class="mdi mdi-plus"></span>Add Supplier
                                  </a>
                                </div> -->
                              </div>

                              <ng-container *ngIf="advancePaidStatus4">
                                <div formArrayName="ObjOrderSupplier"
                                  *ngFor="let t of ObjOrderSupplier1; let i = index">
                                  <div class="form-row" [formGroupName]="i"
                                    *ngIf="t.controls.Status.value==1 || t.controls.Status.value==undefined">

                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                      <label for="" class="d-flex align-items-center">Supplier Name
                                        <span class="required ml-1">*</span>
                                        <a href="javascript:void(0);"
                                          class="btn-link ml-2 align-items-center d-flex justify-content-center text-danger"
                                          (click)="onDeleteSupplier(i)" ngbTooltip="Delete">
                                          <span class="fa fa-trash"></span>
                                        </a>
                                      </label>
                                      <ng-select [items]="showname" bindValue="id" bindLabel="itemName"
                                        formControlName="Supplier" placeholder="Select Supplier" class="wrap-text"
                                        [ngClass]="{ 'is-invalid': submitted && t.get('Supplier').errors}">
                                      </ng-select>
                                      <div *ngIf="submitted && 
                                             t.get('Supplier').hasError('required') && t.get('Supplier').errors"
                                        class="invalid-feedback">
                                        <span style="color:red !important; font-size: 12px;">
                                          Supplier is required</span>
                                      </div>
                                    </div>

                                    <div>
                                      <input type="text" class="form-control" formControlName="Status"
                                        [(ngModel)]="rowvalue[i]" hidden />
                                    </div>

                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                      <label for="" class="d-flex align-items-center">Expected PO/AGR Release
                                        Date
                                        <span class="required ml-1">*</span></label>
                                      <div class="input-group">
                                        <input type="text" class="bg-calender-icon form-control"
                                          formControlName="ExpectedPOAGRReleaseDate" id="inlineFormInputGroup"
                                          placeholder="DD-MM-YYY" bsDatepicker autocomplete="off"
                                          [minDate]="InquiryReceivedDate" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
                                          (keydown)="disableDate()"
                                          [ngClass]="{ 'is-invalid': submitted && t.get('ExpectedPOAGRReleaseDate').errors}">
                                        <div
                                          *ngIf="submitted && t.get('ExpectedPOAGRReleaseDate').hasError('required') && t.get('ExpectedPOAGRReleaseDate').errors"
                                          class="invalid-feedback">
                                          <span style="color:red !important; font-size: 12px;">
                                            Expected PO/AGR Release Date is required</span>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="form-group col-lg-6 col-md-12 col-sm-12">
                                      <label for="" class="d-flex  align-items-center">Supplier PO Remarks
                                        <!-- <span class="required ml-1">*</span> -->
                                      </label>
                                      <textarea class="form-control" id="{{'PORemark'+i}}" formControlName="PORemark"
                                        maxlength="200"></textarea>
                                    </div>

                                  </div>
                                </div>
                              </ng-container>

                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Sub Contractor PO/ AGR
                                    <span class="required ml-1">*</span>
                                    <span
                                      class="mdi mdi-plus mdi-18px cursor-pointer ml-2 btn btn-sm rounded-0 btn-info btn-min-width p-0"
                                      title="Add Sub Contractor" *ngIf="PaymentTermInfo.value.SubContractor !== 'false'"
                                      (click)="addContract()"></span>
                                  </label>
                                  <select class="form-control" formControlName="SubContractor"
                                    (change)="contractMode($event.target.value)">
                                    <option value="true">Applicable</option>
                                    <option value="false">Not Applicable</option>
                                  </select>
                                </div>
                                <!-- <div class="form-group col-lg-3 col-md-6 col-sm-12"
                                  *ngIf="PaymentTermInfo.value.SubContractor !== 'false'">
                                  <label for="" class="d-flex  align-items-center">&nbsp; </label>
                                  <a href="javascript:void(0)" class="btn btn-info text-white" (click)="addContract()">
                                    <span class="mdi mdi-plus"></span> Add Sub Contractor
                                  </a>
                                </div> -->
                              </div>

                              <ng-container *ngIf="advancePaidStatus7">
                                <div formArrayName="ObjOrderSubContractor"
                                  *ngFor="let t of ObjOrderSubContractor1; let i = index">
                                  <div class="form-row" [formGroupName]="i"
                                    *ngIf="t.controls.Status.value==1 || t.controls.Status.value==undefined">

                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                      <label for="" class="d-flex  align-items-center">Sub Contractor Name
                                        <span class="required ml-1">*</span> <a href="javascript:void(0);"
                                          class="btn-link ml-2 align-items-center d-flex justify-content-center text-danger"
                                          (click)="onDeleteSubContract(i)" ngbTooltip="Delete">
                                          <span class="fa fa-trash"></span>
                                        </a>
                                      </label>
                                      <ng-select [items]="showncontrat" bindValue="id" bindLabel="itemName"
                                        formControlName="Supplier" placeholder="Select Contractor"
                                        [ngClass]="{ 'is-invalid': submitted && t.get('Supplier').errors}">
                                      </ng-select>
                                      <div *ngIf="submitted && 
                                      t.get('Supplier').hasError('required') && t.get('Supplier').errors"
                                        class="invalid-feedback">
                                        <span style="color:red !important; font-size: 12px;">
                                          Contractor is required</span>
                                      </div>
                                    </div>

                                    <div>
                                      <input type="text" class="form-control" formControlName="Status"
                                        [(ngModel)]="contractvalue[i]" hidden />
                                    </div>

                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                      <label for="" class="d-flex  align-items-center">Expected PO/AGR Release
                                        Date
                                        <!-- <span class="required ml-1">*</span> -->
                                      </label>
                                      <div class="input-group">
                                        <input type="text" class="bg-calender-icon form-control"
                                          id="inlineFormInputGroup" placeholder="DD-MM-YYYY" bsDatepicker
                                          [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}" autocomplete="off"
                                          [minDate]="InquiryReceivedDate" formControlName="ExpectedPOAGRReleaseDate"
                                          (keydown)="disableDate()">
                                        <!-- <div
                                          *ngIf="submitted && t.get('ExpectedPOAGRReleaseDate').hasError('required') && t.get('ExpectedPOAGRReleaseDate').errors"
                                          class="invalid-feedback">
                                          <span style="color:red !important; font-size: 12px;">
                                            Expected PO/AGR Release Date is required</span>
                                        </div> -->
                                      </div>
                                    </div>

                                    <div class="form-group col-lg-6 col-md-12 col-sm-12">
                                      <label for="" class="d-flex  align-items-center">Sub Contractor PO Remarks
                                        <!-- <span class="required ml-1">*</span> -->
                                      </label>
                                      <textarea class="form-control" formControlName="PORemark"
                                        maxlength="200"></textarea>
                                    </div>

                                  </div>
                                </div>
                              </ng-container>

                              <div class="row mb-3">
                                <div class="col-lg-12">
                                  <a href="javascript:void(0);" class="btn btn-info" (click)="onSubmit5()">Save</a>
                                </div>
                              </div>
                            </form>
                            <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                          </ng-template>
                        </ngb-panel>

                        <ngb-panel title="Special Project Requirements" class="fade">
                          <ng-template ngbPanelContent *ngIf="check >= 4 || ProjectReq == true">
                            <form [formGroup]="ProjectRequirement">
                              <div class="form-row">
                                <div class="form-group col-lg-12 col-md-12 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Special Requirements in Inquiry
                                    <span class="required ml-1">*</span></label>
                                  <textarea class="form-control" formControlName="SpecialRequirement"></textarea>
                                  <div
                                    *ngIf="ProjectRequirement.get('SpecialRequirement').invalid && ProjectRequirement.get('SpecialRequirement').errors && (ProjectRequirement.get('SpecialRequirement').dirty || ProjectRequirement.get('SpecialRequirement').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="ProjectRequirement.get('SpecialRequirement').hasError('required')">
                                      Special Requirement is Required.
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-4 col-sm-12 d-flex align-items-start">
                                  <label for="" class="d-flex  align-items-center">Risk Involved
                                    <span class="required ml-1">*</span></label>

                                  <div class="form-check form-check-inline d-flex ml-3">
                                    <input class="form-check-input" type="radio" formControlName="RiskInvolved"
                                      (change)="modo9($event.target.value)" value="true">
                                    <label class="form-check-label">
                                      Yes
                                    </label> &nbsp; &nbsp;
                                    <input class="form-check-input" type="radio" formControlName="RiskInvolved"
                                      (change)="modo9($event.target.value)" value="false">
                                    <label class="form-check-label">
                                      No
                                    </label>
                                  </div>
                                </div>
                                <div class="form-group col-lg-4 col-md-4 col-sm-12" *ngIf="advancePaidStatus9">
                                  <label for="" class="d-flex  align-items-center">Risk Remarks <span
                                      class="required ml-1">*</span>
                                  </label>
                                  <textarea class="form-control" formControlName="RiskRemark"
                                    (input)="checkReq($event)"></textarea>
                                  <div *ngIf="this.chkRisk == true">
                                    <small class="text-danger">
                                      Risk Remarks is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-lg-4 col-md-4 col-sm-12" *ngIf="advancePaidStatus9">
                                  <label for="" class="d-flex  align-items-center">Risk Mitigation Plan <span
                                      class="required ml-1">*</span>
                                  </label>
                                  <textarea class="form-control" formControlName="RiskMitigationPlan"
                                    (input)="checkReq($event)"></textarea>
                                  <div *ngIf="this.chkRiskM == true">
                                    <small class="text-danger">
                                      Risk Mitigation Plan is Required.
                                    </small>
                                  </div>
                                </div>
                              </div>

                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-4 col-sm-12 d-flex align-items-start">
                                  <label for="" class="d-flex  align-items-center">Penalties
                                    <span class="required ml-1">*</span></label>
                                  <div class="form-check form-check-inline d-flex ml-3">
                                    <input class="form-check-input" type="radio" formControlName="Penalties"
                                      value="true" (change)="modo10($event.target.value)">
                                    <label class="form-check-label">
                                      Yes
                                    </label> &nbsp; &nbsp;
                                    <input class="form-check-input" type="radio" formControlName="Penalties"
                                      value="false" (change)="modo10($event.target.value)">
                                    <label class="form-check-label">
                                      No
                                    </label>
                                  </div>
                                </div>
                                <div class="form-group col-lg-4 col-md-4 col-sm-12" *ngIf="advancePaidStatus10">
                                  <label for="" class="d-flex  align-items-center">Penalties Remarks
                                    <span class="required ml-1">*</span></label>
                                  <textarea class="form-control" formControlName="PenaltiesRemark"></textarea>
                                  <div *ngIf="this.chkPen == true">
                                    <small class="text-danger">
                                      Penalties Remarks is Required.
                                    </small>
                                  </div>
                                </div>
                              </div>

                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-4 col-sm-12 d-flex align-items-start">
                                  <label for="" class="d-flex align-items-center">Deviation Contract<span
                                      class="required ml-1">*</span></label>
                                  <div class="form-check form-check-inline d-flex ml-3">
                                    <input class="form-check-input" type="radio" formControlName="DeviationContract"
                                      value="true" (change)="modo11($event.target.value)">
                                    <label class="form-check-label">
                                      Yes
                                    </label>
                                    <input class="form-check-input" type="radio" formControlName="DeviationContract"
                                      value="false" (change)="modo11($event.target.value)">
                                    <label class="form-check-label">
                                      No
                                    </label>
                                  </div>
                                </div>
                                <div class="form-group col-lg-4 col-md-4 col-sm-12" *ngIf="advancePaidStatus11">
                                  <label for="" class="d-flex  align-items-center">Deviation Contract Remarks
                                    <span class="required ml-1">*</span></label>
                                  <textarea class="form-control" formControlName="DeviationContractRemark"></textarea>
                                  <div *ngIf="this.chkDev == true">
                                    <small class="text-danger">
                                      Deviation Contract Remarks is Required.
                                    </small>
                                  </div>
                                </div>
                              </div>

                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-4 col-sm-12 d-flex align-items-start">
                                  <label for="" class="d-flex  align-items-center">Retention
                                    <span class="required ml-1">*</span></label>
                                  <div class="form-check form-check-inline d-flex ml-3">
                                    <input class="form-check-input" type="radio" formControlName="Retention"
                                      value="true" (change)="modo12($event.target.value)">
                                    <label class="form-check-label">
                                      Yes
                                    </label> &nbsp; &nbsp;
                                    <input class="form-check-input" type="radio" formControlName="Retention"
                                      value="false" (change)="modo12($event.target.value)">
                                    <label class="form-check-label">
                                      No
                                    </label>
                                  </div>
                                </div>
                                <div class="form-group col-lg-4 col-md-8 col-sm-12" *ngIf="advancePaidStatus12">
                                  <label for="" class="d-flex  align-items-center">Retention Remarks
                                    <span class="required ml-1">*</span></label>
                                  <textarea class="form-control" formControlName="RetentionRemark"></textarea>
                                  <div *ngIf="this.chkRet == true">
                                    <small class="text-danger">
                                      Retention Remarks is Required.
                                    </small>
                                  </div>
                                </div>
                              </div>

                              <div class="form-row">
                                <div class="form-group col-lg-3 col-md-4 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">PBG/Guarantee Cheque
                                    <span class="required ml-1">*</span></label>
                                  <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" formControlName="PBGGaurantee"
                                      value="true" (change)="modo13($event.target.value)">
                                    <label class="form-check-label">
                                      Yes
                                    </label> &nbsp; &nbsp;
                                    <input class="form-check-input" type="radio" formControlName="PBGGaurantee"
                                      value="false" (change)="modo13($event.target.value)">
                                    <label class="form-check-label">
                                      No
                                    </label>
                                  </div>
                                </div>
                                <div class="form-group col-lg-9 col-md-8 col-sm-12" *ngIf="advancePaidStatus13">
                                  <div class="table-responsive">
                                    <table class="table hover table-striped table-bordered mb-0" aria-hidden="true">
                                      <thead>
                                        <tr>
                                          <th>Guarantee Purpose</th>
                                          <th>Guarantee Percentage</th>
                                          <th>Guarantee Type</th>
                                          <th>Remarks</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <ng-container formGroupName='Advance'>
                                            <td><input class="form-control-plaintext" formControlName="GauranteePurpose"
                                                readonly>
                                            </td>
                                            <td>
                                              <select class="form-control" formControlName="GauranteePer">
                                                <option value="0" selected>0</option>
                                                <option>5</option>
                                                <option>10</option>
                                                <option>15</option>
                                                <option>20</option>
                                                <option>25</option>
                                                <option>30</option>
                                                <option>35</option>
                                                <option>40</option>
                                                <option>50</option>
                                                <option>60</option>
                                                <option>70</option>
                                                <option>80</option>
                                                <option>90</option>
                                                <option>100</option>
                                              </select>
                                            </td>
                                            <td>
                                              <select class="form-control pl-1" formControlName="GauranteeType"
                                                [(ngModel)]="selectedguarntee"
                                                (ngModelChange)="selectedguarnteeId = $event">
                                                <option value="0" selected>Select Guarantee</option>
                                                <option [value]="item.Id" *ngFor="let item of guarnteTyp; index as i;">
                                                  {{item.Name}}</option>
                                              </select>
                                            </td>
                                            <td>
                                              <textarea class="form-control" formControlName="Remark"
                                                maxlength="200"></textarea>
                                            </td>
                                          </ng-container>
                                        </tr>
                                        <tr>
                                          <ng-container formGroupName='AgainstSupply'>
                                            <td><input class="form-control-plaintext" formControlName="GauranteePurpose"
                                                readonly>
                                            </td>
                                            <td>
                                              <select class="form-control" formControlName="GauranteePer">
                                                <option value="0" selected>0</option>
                                                <option>5</option>
                                                <option>10</option>
                                                <option>15</option>
                                                <option>20</option>
                                                <option>25</option>
                                                <option>30</option>
                                                <option>35</option>
                                                <option>40</option>
                                                <option>50</option>
                                                <option>60</option>
                                                <option>70</option>
                                                <option>80</option>
                                                <option>90</option>
                                                <option>100</option>
                                              </select>
                                            </td>
                                            <td>
                                              <select class="form-control pl-1" formControlName="GauranteeType"
                                                [(ngModel)]="selectedguarntee1">
                                                <option value="0" selected>Select Guarantee</option>
                                                <option [value]="item['Id']"
                                                  *ngFor="let item of guarnteTyp; index as i;">
                                                  {{item['Name']}}</option>
                                              </select>
                                            </td>
                                            <td>
                                              <textarea class="form-control" formControlName="Remark"
                                                maxlength="200"></textarea>
                                            </td>
                                          </ng-container>
                                        </tr>
                                        <tr>
                                          <ng-container formGroupName='AgainstTC'>
                                            <td><input class="form-control-plaintext" formControlName="GauranteePurpose"
                                                readonly>
                                            </td>
                                            <td>
                                              <select class="form-control" formControlName="GauranteePer">
                                                <option value="0" selected>0</option>
                                                <option>5</option>
                                                <option>10</option>
                                                <option>15</option>
                                                <option>20</option>
                                                <option>25</option>
                                                <option>30</option>
                                                <option>35</option>
                                                <option>40</option>
                                                <option>50</option>
                                                <option>60</option>
                                                <option>70</option>
                                                <option>80</option>
                                                <option>90</option>
                                                <option>100</option>
                                              </select>
                                            </td>
                                            <td>
                                              <select class="form-control pl-1" formControlName="GauranteeType"
                                                [(ngModel)]="selectedguarntee2">
                                                <option value="0" selected>Select Guarantee</option>
                                                <option [value]="item['Id']"
                                                  *ngFor="let item of guarnteTyp; index as i;">
                                                  {{item['Name']}}</option>
                                              </select>
                                            </td>
                                            <td>
                                              <textarea class="form-control" formControlName="Remark"
                                                maxlength="200"></textarea>
                                            </td>
                                          </ng-container>
                                        </tr>
                                        <tr>
                                          <ng-container formGroupName='AgainstRetention'>
                                            <td><input class="form-control-plaintext" formControlName="GauranteePurpose"
                                                readonly>
                                            </td>
                                            <td>
                                              <select class="form-control" formControlName="GauranteePer">
                                                <option value="0" selected>0</option>
                                                <option>5</option>
                                                <option>10</option>
                                                <option>15</option>
                                                <option>20</option>
                                                <option>25</option>
                                                <option>30</option>
                                                <option>35</option>
                                                <option>40</option>
                                                <option>50</option>
                                                <option>60</option>
                                                <option>70</option>
                                                <option>80</option>
                                                <option>90</option>
                                                <option>100</option>
                                              </select>
                                            </td>
                                            <td>
                                              <select class="form-control pl-1" formControlName="GauranteeType"
                                                [(ngModel)]="selectedguarntee3">
                                                <option value="0" selected>Select Guarantee</option>
                                                <option [value]="item['Id']"
                                                  *ngFor="let item of guarnteTyp; index as i;">
                                                  {{item['Name']}}</option>
                                              </select>
                                            </td>
                                            <td>
                                              <textarea class="form-control" formControlName="Remark"
                                                maxlength="200"></textarea>
                                            </td>
                                          </ng-container>
                                        </tr>
                                        <tr>
                                          <ng-container formGroupName='AgainstDLP'>
                                            <td><input class="form-control-plaintext" formControlName="GauranteePurpose"
                                                readonly>
                                            </td>
                                            <td>
                                              <select class="form-control" formControlName="GauranteePer">
                                                <option value="0" selected>0</option>
                                                <option>5</option>
                                                <option>10</option>
                                                <option>15</option>
                                                <option>20</option>
                                                <option>25</option>
                                                <option>30</option>
                                                <option>35</option>
                                                <option>40</option>
                                                <option>50</option>
                                                <option>60</option>
                                                <option>70</option>
                                                <option>80</option>
                                                <option>90</option>
                                                <option>100</option>
                                              </select>
                                            </td>
                                            <td>
                                              <select class="form-control pl-1" formControlName="GauranteeType"
                                                [(ngModel)]="selectedguarntee4">
                                                <option value="0" selected>Select Guarantee</option>
                                                <option [value]="item['Id']"
                                                  *ngFor="let item of guarnteTyp; index as i;">
                                                  {{item['Name']}}</option>
                                              </select>
                                            </td>
                                            <td>
                                              <textarea class="form-control" formControlName="Remark"
                                                maxlength="200"></textarea>
                                            </td>
                                          </ng-container>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>

                              <div class="row mb-3">
                                <div class="col-lg-12">
                                  <a href="javascript:void(0);" class="btn btn-info" (click)="onSubmit4()">Save</a>
                                </div>
                              </div>
                            </form>
                            <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                          </ng-template>
                        </ngb-panel>

                        <ngb-panel title="Prepared By / Assigned to / Approved by" class="fade">
                          <ng-template ngbPanelContent *ngIf="check >= 5 || ApprovedBy == true">
                            <form [formGroup]="approvedBy">
                              <div class="form-row">
                                <div class="form-group col-md-4 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Quotation Engineer
                                    <span class="required ml-1">*</span></label>
                                  <angular2-multiselect formControlName="QuotationEngineer" [data]="quotation"
                                    [(ngModel)]="selectedQuotation" [settings]="dropdownSetting0"
                                    (onSelect)="onQuotationSelect($event)" (onDeSelect)="onQuotationSelect($event)"
                                    (onSelectAll)="onQuotationSelect($event)"
                                    (onDeSelectAll)="onQuotationSelect($event)" fixSearchBug>
                                  </angular2-multiselect>
                                  <div
                                    *ngIf="approvedBy.get('QuotationEngineer').invalid && approvedBy.get('QuotationEngineer').errors && (approvedBy.get('QuotationEngineer').dirty || approvedBy.get('QuotationEngineer').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="approvedBy.get('QuotationEngineer').hasError('required')">
                                      Quotation Engineer is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-md-4 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Commercial Executive
                                    <span class="required ml-1">*</span></label>
                                  <angular2-multiselect formControlName="CommercialExecutive" [data]="commercial"
                                    [(ngModel)]="selectedCommercial" [settings]="dropdownSetting2"
                                    (onSelect)="onCommercialSelect($event)" (onDeSelect)="onCommercialSelect($event)"
                                    (onSelectAll)="onCommercialSelect($event)"
                                    (onDeSelectAll)="onCommercialSelect($event)" fixSearchBug>
                                  </angular2-multiselect>
                                  <div
                                    *ngIf="approvedBy.get('CommercialExecutive').invalid && approvedBy.get('CommercialExecutive').errors && (approvedBy.get('CommercialExecutive').dirty || approvedBy.get('CommercialExecutive').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="approvedBy.get('CommercialExecutive').hasError('required')">
                                      Commercial Executive is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-md-4 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Sales Engineer
                                    <span class="required ml-1">*</span></label>
                                  <angular2-multiselect formControlName="SalesEngineer" [data]="sales"
                                    [(ngModel)]="selectedSales" [settings]="dropdownSetting1"
                                    (onSelect)="onSalesSelect($event)" (onDeSelect)="onSalesSelect($event)"
                                    fixSearchBug>
                                  </angular2-multiselect>
                                  <div
                                    *ngIf="approvedBy.get('SalesEngineer').invalid && approvedBy.get('SalesEngineer').errors && (approvedBy.get('SalesEngineer').dirty || approvedBy.get('SalesEngineer').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="approvedBy.get('SalesEngineer').hasError('required')">
                                      Sales Engineer is Required.
                                    </small>
                                  </div>
                                </div>
                              </div>

                              <div class="form-row">
                                <div class="form-group col-md-4 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Sales Manager
                                  </label>
                                  <angular2-multiselect formControlName="SalesManager" [data]="manager"
                                    [(ngModel)]="selectedManager" [settings]="dropdownSetting3"
                                    (onSelect)="onManagerSelect($event)" (onDeSelect)="onManagerSelect($event)"
                                    (onSelectAll)="onManagerSelect($event)" (onDeSelectAll)="onManagerSelect($event)"
                                    fixSearchBug>
                                  </angular2-multiselect>
                                </div>

                                <div class="form-group col-md-4 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">Finance Manager
                                    <span class="required ml-1">*</span></label>
                                  <angular2-multiselect formControlName="FinanceManager" [data]="finance"
                                    [(ngModel)]="selectedFinance" [settings]="dropdownSetting4"
                                    (onSelect)="onFinanceSelect($event)" (onDeSelect)="onFinanceSelect($event)"
                                    (onSelectAll)="onFinanceSelect($event)" (onDeSelectAll)="onFinanceSelect($event)"
                                    fixSearchBug>
                                  </angular2-multiselect>
                                  <div
                                    *ngIf="approvedBy.get('FinanceManager').invalid && approvedBy.get('FinanceManager').errors && (approvedBy.get('FinanceManager').dirty || approvedBy.get('FinanceManager').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="approvedBy.get('FinanceManager').hasError('required')">
                                      Finance Manager is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="form-group col-md-4 col-sm-12">
                                  <label for="" class="d-flex  align-items-center">General Manager
                                    <span class="required ml-1">*</span></label>
                                  <angular2-multiselect formControlName="GeneralManager" [data]="general"
                                    [(ngModel)]="selectedGeneral" [settings]="dropdownSetting5"
                                    (onSelect)="onGeneralSelect($event)" (onDeSelect)="onGeneralSelect($event)"
                                    (onSelectAll)="onGeneralSelect($event)" (onDeSelectAll)="onGeneralSelect($event)"
                                    fixSearchBug>
                                  </angular2-multiselect>
                                  <div
                                    *ngIf="approvedBy.get('GeneralManager').invalid && approvedBy.get('GeneralManager').errors && (approvedBy.get('GeneralManager').dirty || approvedBy.get('GeneralManager').touched) || submitted">
                                    <small class="text-danger"
                                      *ngIf="approvedBy.get('GeneralManager').hasError('required')">
                                      General Manager is Required.
                                    </small>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-12">
                                    <a href="javascript:void(0);" class="btn btn-info" (click)="onSubmit3()">Submit</a>
                                  </div>
                                </div>
                              </div>
                            </form>
                            <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                          </ng-template>
                        </ngb-panel>

                      </ngb-accordion>

                    </div>
                  </div>

                </ng-template>
              </ngb-tab>

              <ngb-tab id="tab-selectbyid2" *ngIf="permission.OrderReview_View==1 || userRId==1">
                <ng-template ngbTabTitle>
                  <div (click)="tabclick1(id)">
                    Order Review Attachments
                  </div>
                </ng-template>
                <ng-template ngbTabContent>
                  <app-orderattachment></app-orderattachment>
                </ng-template>
              </ngb-tab>

            </ngb-tabset>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Item Vat% Info-->
<div class="modal fade" bsModal #vatDocument="bs-modal" [config]="{backdrop: 'static', keyboard: false}" tabindex="-1"
  role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content animated zoomIn">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">tax Result</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="vatDocument.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button href="javascript:void(0);" class="btn btn-sm btn btn-info">TaxResult</button>
        <input #showvat (click)="vatResult.show()" type="hidden">
        <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2" (click)="vatDocument.hide()">Close</a>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #vatResult="bs-modal" [config]="{backdrop: 'static', keyboard: false}" tabindex="-1"
  role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content animated zoomIn">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Item Tax% Info</h4>
      </div>
      <div class="modal-body">
        <form action="">
          <div class="form-row animated fadeIn">
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Tax % should be same for same ItemCode
                </label>
              </div>
            </div>
          </div>

          <div class="form-row animated fadeIn">
            <div class="col-lg-12 col-md-12">
              <div class="table-responsive" style="max-height: 300px;">
                <table class="table mb-0" aria-hidden="true">
                  <tbody>
                    <tr *ngFor="let item of dataarray; let i = index">
                      <td>Row No. {{item.RowNo}}</td>
                      <td>{{item.ItemCode}}</td>
                      <td>{{item.VatRate}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <a href="javascript:void(0);" (click)="vatResult.hide(); vatDocument.hide();"
          class="btn btn-sm btn btn-info">OK</a>
      </div>
    </div>
  </div>
</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>